export const DEFAULT_WORDS = [
  {
    id: 1,
    word: 'aboutir',
    phonetic: '/abutir/',
    type: 'v.i.',
    translation: '导致；成功',
    commonMeanings: ['导致', '成功'],
    example: 'Ce projet a enfin abouti.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'aboutissement',
        type: 'n.m.',
        meaning: '结果',
        usage: "C'est l'aboutissement de son travail.",
        example: "C'est l'aboutissement de son travail.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 2,
    word: 'accueillir',
    phonetic: '/akœjir/',
    type: 'v.t.',
    translation: '接待；欢迎',
    commonMeanings: ['接待', '欢迎'],
    example: 'Elle nous a accueillis avec le sourire.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'accueil',
        type: 'n.m.',
        meaning: '接待',
        usage: "L'accueil a été très chaleureux.",
        example: "L'accueil a été très chaleureux.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 3,
    word: 'acquérir',
    phonetic: '/akerir/',
    type: 'v.t.',
    translation: '获得；购得',
    commonMeanings: ['获得', '购得'],
    example: 'Il a acquis une grande expérience.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'acquisition',
        type: 'n.f.',
        meaning: '获得',
        usage: "L'acquisition de connaissances.",
        example: "L'acquisition de connaissances.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 4,
    word: 'admettre',
    phonetic: '/admɛtr/',
    type: 'v.t.',
    translation: '承认；准许',
    commonMeanings: ['承认', '准许'],
    example: 'Il a admis son erreur.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'admission',
        type: 'n.f.',
        meaning: '录取',
        usage: 'Son admission est confirmée.',
        example: 'Son admission est confirmée.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 5,
    word: 'apercevoir',
    phonetic: '/apɛrsəvwar/',
    type: 'v.t.',
    translation: '瞥见；觉察',
    commonMeanings: ['瞥见', '觉察'],
    example: "J'ai aperçu Pierre dans la foule.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'aperçu',
        type: 'n.m.',
        meaning: '概述；概况',
        usage: 'Donnez-moi un aperçu du projet.',
        example: 'Donnez-moi un aperçu du projet.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 6,
    word: 'appartenir',
    phonetic: '/apartənir/',
    type: 'v.i.',
    translation: '属于',
    commonMeanings: ['属于'],
    example: 'Ce livre appartient à mon frère.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'appartenance',
        type: 'n.f.',
        meaning: '归属',
        usage: "Le sentiment d'appartenance.",
        example: "Le sentiment d'appartenance.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 7,
    word: 'atteindre',
    phonetic: '/atɛ̃dr/',
    type: 'v.t.',
    translation: '达到；到达',
    commonMeanings: ['达到', '到达'],
    example: 'Nous avons atteint notre but.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'atteinte',
        type: 'n.f.',
        meaning: '达到/损害',
        usage: 'Porter atteinte à la liberté.',
        example: 'Porter atteinte à la liberté.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 8,
    word: "s'abstenir",
    phonetic: '/sabstənir/',
    type: 'v.pr.',
    translation: '弃权；克制',
    commonMeanings: ['弃权', '克制'],
    example: "Il s'abstient de fumer.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'abstention',
        type: 'n.f.',
        meaning: '弃权',
        usage: "Le taux d'abstention est élevé.",
        example: "Le taux d'abstention est élevé.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 9,
    word: 'accroître',
    phonetic: '/akrwatr/',
    type: 'v.t.',
    translation: '增加；增长',
    commonMeanings: ['增加', '增长'],
    example: 'La ville accroît sa population.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'accroissement',
        type: 'n.m.',
        meaning: '增长',
        usage: "L'accroissement des ventes.",
        example: "L'accroissement des ventes.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 10,
    word: 'agir',
    phonetic: '/aʒir/',
    type: 'v.i.',
    translation: '行动；起作用',
    commonMeanings: ['行动', '起作用'],
    example: 'Il faut agir sans tarder.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'action',
        type: 'n.f.',
        meaning: '行动',
        usage: "Passer à l'action.",
        example: "Passer à l'action.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 11,
    word: "s'adapter",
    phonetic: '/sadapte/',
    type: 'v.pr.',
    translation: '适应',
    commonMeanings: ['适应'],
    example: "Il s'adapte vite à son milieu.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'adaptation',
        type: 'n.f.',
        meaning: '适应',
        usage: "L'adaptation au changement.",
        example: "L'adaptation au changement.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 12,
    word: 'améliorer',
    phonetic: '/ameljɔre/',
    type: 'v.t.',
    translation: '改良；提高',
    commonMeanings: ['改良', '提高'],
    example: 'Améliorer votre prononciation.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'amélioration',
        type: 'n.f.',
        meaning: '进步',
        usage: 'Une amélioration de sa santé.',
        example: 'Une amélioration de sa santé.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 13,
    word: 'annoncer',
    phonetic: '/anɔ̃se/',
    type: 'v.t.',
    translation: '宣布；通知',
    commonMeanings: ['宣布', '通知'],
    example: 'Il a annoncé son départ.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'annonce',
        type: 'n.f.',
        meaning: '公告',
        usage: 'Passer une annonce.',
        example: 'Passer une annonce.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 14,
    word: 'apparaître',
    phonetic: '/aparɛtr/',
    type: 'v.i.',
    translation: '出现',
    commonMeanings: ['出现'],
    example: 'Un arc-en-ciel est apparu.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'apparence',
        type: 'n.f.',
        meaning: '外表',
        usage: 'Se fier aux apparences.',
        example: 'Se fier aux apparences.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 15,
    word: 'apprendre',
    phonetic: '/aprɑ̃dr/',
    type: 'v.t.',
    translation: '学习；得知',
    commonMeanings: ['学习', '得知'],
    example: "J'apprends le français.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'apprentissage',
        type: 'n.m.',
        meaning: '学习',
        usage: "L'apprentissage d'une langue.",
        example: "L'apprentissage d'une langue.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 16,
    word: "s'arrêter",
    phonetic: '/sarɛte/',
    type: 'v.pr.',
    translation: '停止',
    commonMeanings: ['停止'],
    example: "La voiture s'arrête au feu.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'arrêt',
        type: 'n.m.',
        meaning: '停止/车站',
        usage: 'Un arrêt de bus.',
        example: 'Un arrêt de bus.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 17,
    word: "s'asseoir",
    phonetic: '/saswar/',
    type: 'v.pr.',
    translation: '坐下',
    commonMeanings: ['坐下'],
    example: "Asseyez-vous, s'il vous plaît.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'assise',
        type: 'n.f.',
        meaning: '基础',
        usage: "Les assises d'une société.",
        example: "Les assises d'une société.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 18,
    word: 'assurer',
    phonetic: '/asyre/',
    type: 'v.t.',
    translation: '保证；保险',
    commonMeanings: ['保证', '保险'],
    example: "Il assure qu'il viendra.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'assurance',
        type: 'n.f.',
        meaning: '保险/自信',
        usage: 'Une assurance vie.',
        example: 'Une assurance vie.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 19,
    word: 'attendre',
    phonetic: '/atɑ̃dr/',
    type: 'v.t.',
    translation: '等待',
    commonMeanings: ['等待'],
    example: "J'attends le bus.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'attente',
        type: 'n.f.',
        meaning: '等待',
        usage: "Salle d'attente.",
        example: "Salle d'attente.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 20,
    word: 'augmenter',
    phonetic: '/oɡmɑ̃te/',
    type: 'v.t./v.i.',
    translation: '增加',
    commonMeanings: ['增加'],
    example: 'Le prix a augmenté.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'augmentation',
        type: 'n.f.',
        meaning: '增加',
        usage: 'Une augmentation de salaire.',
        example: 'Une augmentation de salaire.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 21,
    word: 'avancer',
    phonetic: '/avɑ̃se/',
    type: 'v.t./v.i.',
    translation: '前进；推进',
    commonMeanings: ['前进', '推进'],
    example: 'Les travaux avancent vite.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'avance',
        type: 'n.f.',
        meaning: '前进/预付款',
        usage: 'Faire une avance.',
        example: 'Faire une avance.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 22,
    word: 'avertir',
    phonetic: '/avɛrtir/',
    type: 'v.t.',
    translation: '通知；警告',
    commonMeanings: ['通知', '警告'],
    example: 'Je vous avertis du danger.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'avertissement',
        type: 'n.m.',
        meaning: '警告',
        usage: 'Recevoir un avertissement.',
        example: 'Recevoir un avertissement.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 23,
    word: 'battre',
    phonetic: '/batr/',
    type: 'v.t.',
    translation: '打；击败',
    commonMeanings: ['打', '击败'],
    example: "Notre équipe a battu l'adversaire.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'bataille',
        type: 'n.f.',
        meaning: '战役',
        usage: 'Une grande bataille.',
        example: 'Une grande bataille.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 24,
    word: 'bénéficier',
    phonetic: '/benefisje/',
    type: 'v.i.',
    translation: '得益；享受',
    commonMeanings: ['得益', '享受'],
    example: "Il bénéficie d'une bourse.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'bénéfice',
        type: 'n.m.',
        meaning: '利润',
        usage: 'Faire du bénéfice.',
        example: 'Faire du bénéfice.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 25,
    word: 'boire',
    phonetic: '/bwar/',
    type: 'v.t.',
    translation: '喝；饮',
    commonMeanings: ['喝', '饮'],
    example: 'Voulez-vous boire un café ?',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'boisson',
        type: 'n.f.',
        meaning: '饮料',
        usage: 'Une boisson fraîche.',
        example: 'Une boisson fraîche.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 26,
    word: 'bouger',
    phonetic: '/buʒe/',
    type: 'v.t./v.i.',
    translation: '移动；晃动',
    commonMeanings: ['移动', '晃动'],
    example: 'Ne bougez pas !',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'bouge',
        type: 'n.m.',
        meaning: '破旧小屋',
        usage: 'Vivre dans un bouge.',
        example: 'Vivre dans un bouge.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 27,
    word: 'briller',
    phonetic: '/brije/',
    type: 'v.i.',
    translation: '发光；出众',
    commonMeanings: ['发光', '出众'],
    example: 'Le soleil brille.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'brillant',
        type: 'adj.',
        meaning: '灿烂的',
        usage: 'Un avenir brillant.',
        example: 'Un avenir brillant.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 28,
    word: 'briser',
    phonetic: '/brize/',
    type: 'v.t.',
    translation: '打碎；折断',
    commonMeanings: ['打碎', '折断'],
    example: 'Il a brisé le miroir.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'bris',
        type: 'n.m.',
        meaning: '破碎',
        usage: 'Le bris de glace.',
        example: 'Le bris de glace.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 29,
    word: 'changer',
    phonetic: '/ʃɑ̃ʒe/',
    type: 'v.t./v.i.',
    translation: '改变；换',
    commonMeanings: ['改变', '换'],
    example: 'Changer de train.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'changement',
        type: 'n.m.',
        meaning: '变化',
        usage: 'Un changement radical.',
        example: 'Un changement radical.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 30,
    word: 'chanter',
    phonetic: '/ʃɑ̃te/',
    type: 'v.t./v.i.',
    translation: '唱歌',
    commonMeanings: ['唱歌'],
    example: 'Elle chante très bien.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'chanson',
        type: 'n.f.',
        meaning: '歌曲',
        usage: 'Écouter une chanson.',
        example: 'Écouter une chanson.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 31,
    word: 'charger',
    phonetic: '/ʃarʒe/',
    type: 'v.t.',
    translation: '装载；负责',
    commonMeanings: ['装载', '负责'],
    example: 'Charger la voiture.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'charge',
        type: 'n.f.',
        meaning: '负担',
        usage: 'Prendre en charge.',
        example: 'Prendre en charge.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 32,
    word: 'chasser',
    phonetic: '/ʃase/',
    type: 'v.t.',
    translation: '打猎；驱逐',
    commonMeanings: ['打猎', '驱逐'],
    example: 'Chasser les mouches.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'chasseur',
        type: 'n.m.',
        meaning: '猎人',
        usage: 'Un chasseur sachant chasser.',
        example: 'Un chasseur sachant chasser.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 33,
    word: 'choisir',
    phonetic: '/ʃwazir/',
    type: 'v.t.',
    translation: '选择',
    commonMeanings: ['选择'],
    example: 'Vous devez choisir un plat.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'choix',
        type: 'n.m.',
        meaning: '选择',
        usage: 'Faire un choix difficile.',
        example: 'Faire un choix difficile.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 34,
    word: 'combattre',
    phonetic: '/kɔ̃batr/',
    type: 'v.t.',
    translation: '战斗；反对',
    commonMeanings: ['战斗', '反对'],
    example: 'Combattre la maladie.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'combat',
        type: 'n.m.',
        meaning: '战斗',
        usage: 'Un combat acharné.',
        example: 'Un combat acharné.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 35,
    word: 'commander',
    phonetic: '/kɔmɑ̃de/',
    type: 'v.t.',
    translation: '命令；订购',
    commonMeanings: ['命令', '订购'],
    example: 'Commander un repas.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'commande',
        type: 'n.f.',
        meaning: '订单',
        usage: 'Passer une commande.',
        example: 'Passer une commande.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 36,
    word: 'commencer',
    phonetic: '/kɔmɑ̃se/',
    type: 'v.t.',
    translation: '开始',
    commonMeanings: ['开始'],
    example: 'Le spectacle commence.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'commencement',
        type: 'n.m.',
        meaning: '开始',
        usage: 'Au commencement.',
        example: 'Au commencement.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 37,
    word: 'comprendre',
    phonetic: '/kɔ̃prɑ̃dr/',
    type: 'v.t.',
    translation: '理解；包含',
    commonMeanings: ['理解', '包含'],
    example: 'Je comprends tout.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'compréhension',
        type: 'n.f.',
        meaning: '理解',
        usage: 'La compréhension orale.',
        example: 'La compréhension orale.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 38,
    word: 'conduire',
    phonetic: '/kɔ̃dɥir/',
    type: 'v.t.',
    translation: '驾驶；引导',
    commonMeanings: ['驾驶', '引导'],
    example: 'Conduire une voiture.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'conducteur',
        type: 'n.m.',
        meaning: '司机',
        usage: 'Un bon conducteur.',
        example: 'Un bon conducteur.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 39,
    word: 'confier',
    phonetic: '/kɔ̃fje/',
    type: 'v.t.',
    translation: '委托；吐露',
    commonMeanings: ['委托', '吐露'],
    example: 'Confier un secret.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'confiance',
        type: 'n.f.',
        meaning: '信任',
        usage: 'Avoir confiance en soi.',
        example: 'Avoir confiance en soi.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 40,
    word: 'connaître',
    phonetic: '/kɔnɛtr/',
    type: 'v.t.',
    translation: '认识；了解',
    commonMeanings: ['认识', '了解'],
    example: 'Je connais ce monsieur.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'connaissance',
        type: 'n.f.',
        meaning: '知识/认识',
        usage: 'Faire connaissance.',
        example: 'Faire connaissance.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 41,
    word: 'conquérir',
    phonetic: '/kɔ̃kerir/',
    type: 'v.t.',
    translation: '征服；赢得',
    commonMeanings: ['征服', '赢得'],
    example: 'Conquérir le marché.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'conquête',
        type: 'n.f.',
        meaning: '征服',
        usage: 'Partir à la conquête.',
        example: 'Partir à la conquête.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 42,
    word: 'conseiller',
    phonetic: '/kɔ̃seje/',
    type: 'v.t.',
    translation: '建议；劝告',
    commonMeanings: ['建议', '劝告'],
    example: 'Je vous conseille de partir.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'conseil',
        type: 'n.m.',
        meaning: '建议',
        usage: 'Suivre un conseil.',
        example: 'Suivre un conseil.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 43,
    word: 'consentir',
    phonetic: '/kɔ̃sɑ̃tir/',
    type: 'v.i.',
    translation: '同意',
    commonMeanings: ['同意'],
    example: 'Consentir à un projet.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'consentement',
        type: 'n.m.',
        meaning: '同意',
        usage: 'Sans son consentement.',
        example: 'Sans son consentement.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 44,
    word: 'construire',
    phonetic: '/kɔ̃strɥir/',
    type: 'v.t.',
    translation: '建造',
    commonMeanings: ['建造'],
    example: 'Construire une maison.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'construction',
        type: 'n.f.',
        meaning: '建筑',
        usage: 'En construction.',
        example: 'En construction.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 45,
    word: 'contenir',
    phonetic: '/kɔ̃tnir/',
    type: 'v.t.',
    translation: '包含；克制',
    commonMeanings: ['包含', '克制'],
    example: 'Ce sac contient des fruits.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'contenu',
        type: 'n.m.',
        meaning: '内容',
        usage: 'Le contenu du message.',
        example: 'Le contenu du message.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 46,
    word: 'continuer',
    phonetic: '/kɔ̃tinɥe/',
    type: 'v.t./v.i.',
    translation: '继续',
    commonMeanings: ['继续'],
    example: 'Continuez votre travail.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'continuité',
        type: 'n.f.',
        meaning: '连续性',
        usage: 'Assurer la continuité.',
        example: 'Assurer la continuité.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 47,
    word: 'convaincre',
    phonetic: '/kɔ̃vɛ̃kr/',
    type: 'v.t.',
    translation: '说服',
    commonMeanings: ['说服'],
    example: 'Convaincre le client.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'conviction',
        type: 'n.f.',
        meaning: '信念',
        usage: 'Avec conviction.',
        example: 'Avec conviction.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 48,
    word: 'convenir',
    phonetic: '/kɔ̃vnir/',
    type: 'v.i.',
    translation: '适合；一致',
    commonMeanings: ['适合', '一致'],
    example: 'Cela me convient.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'convention',
        type: 'n.f.',
        meaning: '公约',
        usage: 'Signer une convention.',
        example: 'Signer une convention.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 49,
    word: 'correspondre',
    phonetic: '/kɔrɛspɔ̃dr/',
    type: 'v.i.',
    translation: '符合；通信',
    commonMeanings: ['符合', '通信'],
    example: 'Cela correspond à mes attentes.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'correspondance',
        type: 'n.f.',
        meaning: '通信/换乘',
        usage: 'La correspondance SNCF.',
        example: 'La correspondance SNCF.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 50,
    word: 'courir',
    phonetic: '/kurir/',
    type: 'v.i.',
    translation: '跑',
    commonMeanings: ['跑'],
    example: 'Courir dans le parc.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'course',
        type: 'n.f.',
        meaning: '跑步/购物',
        usage: 'Faire les courses.',
        example: 'Faire les courses.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 51,
    word: 'craindre',
    phonetic: '/krɛ̃dr/',
    type: 'v.t.',
    translation: '害怕；担心',
    commonMeanings: ['害怕', '担心'],
    example: "Je crains qu'il ne pleuve.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'crainte',
        type: 'n.f.',
        meaning: '恐惧',
        usage: 'Vivre dans la crainte.',
        example: 'Vivre dans la crainte.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 52,
    word: 'croire',
    phonetic: '/krwar/',
    type: 'v.t.',
    translation: '相信；认为',
    commonMeanings: ['相信', '认为'],
    example: "Je crois qu'il a raison.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'croyance',
        type: 'n.f.',
        meaning: '信仰',
        usage: 'Les croyances anciennes.',
        example: 'Les croyances anciennes.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 53,
    word: 'cueillir',
    phonetic: '/kœjir/',
    type: 'v.t.',
    translation: '采；摘',
    commonMeanings: ['采', '摘'],
    example: 'Cueillir des fleurs.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'cueillette',
        type: 'n.f.',
        meaning: '采摘',
        usage: 'La cueillette des champignons.',
        example: 'La cueillette des champignons.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 54,
    word: 'décevoir',
    phonetic: '/desəvwar/',
    type: 'v.t.',
    translation: '使失望',
    commonMeanings: ['使失望'],
    example: "Ce film m'a déçu.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'déception',
        type: 'n.f.',
        meaning: '失望',
        usage: 'Quelle déception !',
        example: 'Quelle déception !',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 55,
    word: 'décider',
    phonetic: '/deside/',
    type: 'v.t.',
    translation: '决定',
    commonMeanings: ['决定'],
    example: 'Décider de partir.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'décision',
        type: 'n.f.',
        meaning: '决定',
        usage: 'Prendre une décision.',
        example: 'Prendre une décision.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 56,
    word: 'découvrir',
    phonetic: '/dekuvrir/',
    type: 'v.t.',
    translation: '发现',
    commonMeanings: ['发现'],
    example: 'Découvrir un secret.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'découverte',
        type: 'n.f.',
        meaning: '发现',
        usage: 'Une grande découverte.',
        example: 'Une grande découverte.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 57,
    word: 'décrire',
    phonetic: '/dekrir/',
    type: 'v.t.',
    translation: '描写',
    commonMeanings: ['描写'],
    example: 'Décrire un paysage.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'description',
        type: 'n.f.',
        meaning: '描写',
        usage: 'Faire une description.',
        example: 'Faire une description.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 58,
    word: 'défendre',
    phonetic: '/defɑ̃dr/',
    type: 'v.t.',
    translation: '保卫；禁止',
    commonMeanings: ['保卫', '禁止'],
    example: 'Défendre ses droits.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'défense',
        type: 'n.f.',
        meaning: '防御',
        usage: 'La défense nationale.',
        example: 'La défense nationale.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 59,
    word: 'dépendre',
    phonetic: '/depɑ̃dr/',
    type: 'v.i.',
    translation: '取决于',
    commonMeanings: ['取决于'],
    example: 'Cela dépend du temps.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'dépendance',
        type: 'n.f.',
        meaning: '依赖',
        usage: 'La dépendance économique.',
        example: 'La dépendance économique.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 60,
    word: 'descendre',
    phonetic: '/desɑ̃dr/',
    type: 'v.i.',
    translation: '下来',
    commonMeanings: ['下来'],
    example: "Descendre l'escalier.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'descente',
        type: 'n.f.',
        meaning: '下降',
        usage: 'Une descente rapide.',
        example: 'Une descente rapide.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 61,
    word: 'détruire',
    phonetic: '/detrɥir/',
    type: 'v.t.',
    translation: '破坏',
    commonMeanings: ['破坏'],
    example: 'Le feu détruit tout.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'destruction',
        type: 'n.f.',
        meaning: '毁灭',
        usage: 'La destruction de la ville.',
        example: 'La destruction de la ville.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 62,
    word: 'devenir',
    phonetic: '/dəvnir/',
    type: 'v.i.',
    translation: '变成',
    commonMeanings: ['变成'],
    example: 'Il devient célèbre.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'devenu',
        type: 'adj.',
        meaning: '变成的',
        usage: 'Un rêve devenu réalité.',
        example: 'Un rêve devenu réalité.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 63,
    word: 'deviner',
    phonetic: '/dəvine/',
    type: 'v.t.',
    translation: '猜',
    commonMeanings: ['猜'],
    example: 'Deviner une énigme.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'devinette',
        type: 'n.f.',
        meaning: '谜语',
        usage: 'Poser une devinette.',
        example: 'Poser une devinette.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 64,
    word: 'devoir',
    phonetic: '/dəvwar/',
    type: 'v.t.',
    translation: '应该；欠',
    commonMeanings: ['应该', '欠'],
    example: 'Je dois travailler.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'devoir',
        type: 'n.m.',
        meaning: '义务/作业',
        usage: 'Faire ses devoirs.',
        example: 'Faire ses devoirs.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 65,
    word: 'diminuer',
    phonetic: '/diminɥe/',
    type: 'v.t./v.i.',
    translation: '减少',
    commonMeanings: ['减少'],
    example: 'La pluie diminue.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'diminution',
        type: 'n.f.',
        meaning: '减少',
        usage: 'Une diminution de prix.',
        example: 'Une diminution de prix.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 66,
    word: 'disparaître',
    phonetic: '/disparɛtr/',
    type: 'v.i.',
    translation: '消失',
    commonMeanings: ['消失'],
    example: 'Le soleil disparaît.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'disparition',
        type: 'n.f.',
        meaning: '消失',
        usage: 'La disparition des espèces.',
        example: 'La disparition des espèces.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 67,
    word: 'distinguer',
    phonetic: '/distɛ̃ɡe/',
    type: 'v.t.',
    translation: '区分',
    commonMeanings: ['区分'],
    example: 'Distinguer les couleurs.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'distinction',
        type: 'n.f.',
        meaning: '区别',
        usage: 'Faire une distinction.',
        example: 'Faire une distinction.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 68,
    word: 'dormir',
    phonetic: '/dɔrmir/',
    type: 'v.i.',
    translation: '睡觉',
    commonMeanings: ['睡觉'],
    example: 'Dormir huit heures.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'endormi',
        type: 'adj.',
        meaning: '睡着的',
        usage: 'Un enfant endormi.',
        example: 'Un enfant endormi.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 69,
    word: 'douter',
    phonetic: '/dute/',
    type: 'v.i.',
    translation: '怀疑',
    commonMeanings: ['怀疑'],
    example: 'Je doute de lui.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'doute',
        type: 'n.m.',
        meaning: '怀疑',
        usage: 'Sans aucun doute.',
        example: 'Sans aucun doute.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 70,
    word: 'échapper',
    phonetic: '/eʃape/',
    type: 'v.i.',
    translation: '逃脱',
    commonMeanings: ['逃脱'],
    example: 'Échapper au danger.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'échappement',
        type: 'n.m.',
        meaning: '排气/逃逸',
        usage: "Pot d'échappement.",
        example: "Pot d'échappement.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 71,
    word: 'échouer',
    phonetic: '/eʃwe/',
    type: 'v.i.',
    translation: '失败',
    commonMeanings: ['失败'],
    example: "Échouer à l'examen.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'échec',
        type: 'n.m.',
        meaning: '失败',
        usage: 'Un échec total.',
        example: 'Un échec total.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 72,
    word: 'écouter',
    phonetic: '/ekute/',
    type: 'v.t.',
    translation: '听',
    commonMeanings: ['听'],
    example: 'Écouter la radio.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'écouteur',
        type: 'n.m.',
        meaning: '耳机',
        usage: 'Mettre des écouteurs.',
        example: 'Mettre des écouteurs.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 73,
    word: 'écrire',
    phonetic: '/ekrir/',
    type: 'v.t.',
    translation: '写',
    commonMeanings: ['写'],
    example: 'Écrire une lettre.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'écriture',
        type: 'n.f.',
        meaning: '书写',
        usage: 'Une belle écriture.',
        example: 'Une belle écriture.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 74,
    word: 'effacer',
    phonetic: '/efase/',
    type: 'v.t.',
    translation: '擦掉',
    commonMeanings: ['擦掉'],
    example: 'Effacer le tableau.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'effaceur',
        type: 'n.m.',
        meaning: '消字灵',
        usage: 'Utiliser un effaceur.',
        example: 'Utiliser un effaceur.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 75,
    word: 'élire',
    phonetic: '/elir/',
    type: 'v.t.',
    translation: '选举',
    commonMeanings: ['选举'],
    example: 'Élire un président.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'élection',
        type: 'n.f.',
        meaning: '选举',
        usage: 'Une élection locale.',
        example: 'Une élection locale.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 76,
    word: 'éloigner',
    phonetic: '/elwaɲe/',
    type: 'v.t.',
    translation: '使远离',
    commonMeanings: ['使远离'],
    example: 'Éloigner les enfants.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'éloignement',
        type: 'n.m.',
        meaning: '远离',
        usage: "L'éloignement physique.",
        example: "L'éloignement physique.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 77,
    word: 'embrasser',
    phonetic: '/ɑ̃brase/',
    type: 'v.t.',
    translation: '拥抱/亲吻',
    commonMeanings: ['拥抱/亲吻'],
    example: 'Embrasser ses parents.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'embrassade',
        type: 'n.f.',
        meaning: '拥抱',
        usage: 'Une longue embrassade.',
        example: 'Une longue embrassade.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 78,
    word: 'emmener',
    phonetic: '/ɑ̃mne/',
    type: 'v.t.',
    translation: '带走',
    commonMeanings: ['带走'],
    example: 'Emmener les clés.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'mène',
        type: 'v. (root)',
        meaning: '引导',
        usage: 'Cela ne mène à rien.',
        example: 'Cela ne mène à rien.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 79,
    word: 'empêcher',
    phonetic: '/ɑ̃pɛʃe/',
    type: 'v.t.',
    translation: '阻止',
    commonMeanings: ['阻止'],
    example: 'Empêcher de sortir.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'empêchement',
        type: 'n.m.',
        meaning: '阻碍',
        usage: 'Un empêchement majeur.',
        example: 'Un empêchement majeur.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 80,
    word: 'employer',
    phonetic: '/ɑ̃plwaje/',
    type: 'v.t.',
    translation: '使用/雇佣',
    commonMeanings: ['使用/雇佣'],
    example: 'Employer un outil.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'employé',
        type: 'n.m.',
        meaning: '雇员',
        usage: 'Un employé de bureau.',
        example: 'Un employé de bureau.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 81,
    word: 'emprunter',
    phonetic: '/ɑ̃prœ̃te/',
    type: 'v.t.',
    translation: '借入',
    commonMeanings: ['借入'],
    example: 'Emprunter un livre à la bibliothèque.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'emprunt',
        type: 'n.m.',
        meaning: '借款',
        usage: 'Faire un emprunt bancaire.',
        example: 'Faire un emprunt bancaire.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 82,
    word: 'encourager',
    phonetic: '/ɑ̃kuraʒe/',
    type: 'v.t.',
    translation: '鼓励',
    commonMeanings: ['鼓励'],
    example: 'Encourager ses élèves.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'courage',
        type: 'n.m.',
        meaning: '勇气',
        usage: 'Avoir du courage.',
        example: 'Avoir du courage.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 83,
    word: "s'endormir",
    phonetic: '/sɑ̃dɔrmir/',
    type: 'v.pr.',
    translation: '入睡',
    commonMeanings: ['入睡'],
    example: "Il s'endort devant la télé.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'endormissement',
        type: 'n.m.',
        meaning: '入睡',
        usage: "Un temps d'endormissement long.",
        example: "Un temps d'endormissement long.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 84,
    word: "s'enfuir",
    phonetic: '/sɑ̃fɥir/',
    type: 'v.pr.',
    translation: '逃跑',
    commonMeanings: ['逃跑'],
    example: "Le voleur s'enfuit.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'fuite',
        type: 'n.f.',
        meaning: '逃跑/泄漏',
        usage: 'Prendre la fuite.',
        example: 'Prendre la fuite.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 85,
    word: 'engager',
    phonetic: '/ɑ̃ɡaʒe/',
    type: 'v.t.',
    translation: '雇佣；约束',
    commonMeanings: ['雇佣', '约束'],
    example: 'Engager du personnel.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'engagement',
        type: 'n.m.',
        meaning: '承诺',
        usage: 'Tenir son engagement.',
        example: 'Tenir son engagement.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 86,
    word: 'enlever',
    phonetic: '/ɑ̃lve/',
    type: 'v.t.',
    translation: '脱下；除去',
    commonMeanings: ['脱下', '除去'],
    example: 'Enlever son manteau.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'enlèvement',
        type: 'n.m.',
        meaning: '绑架/撤走',
        usage: "L'enlèvement des ordures.",
        example: "L'enlèvement des ordures.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 87,
    word: 'ennuyer',
    phonetic: '/ɑ̃nɥije/',
    type: 'v.t.',
    translation: '使厌烦；打扰',
    commonMeanings: ['使厌烦', '打扰'],
    example: "Cette musique m'ennuie.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'ennui',
        type: 'n.m.',
        meaning: '烦恼',
        usage: 'Avoir des ennuis.',
        example: 'Avoir des ennuis.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 88,
    word: 'enseigner',
    phonetic: '/ɑ̃seɲe/',
    type: 'v.t.',
    translation: '教；教导',
    commonMeanings: ['教', '教导'],
    example: 'Enseigner le français.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'enseignant',
        type: 'n.m.',
        meaning: '教师',
        usage: 'Un bon enseignant.',
        example: 'Un bon enseignant.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 89,
    word: 'entendre',
    phonetic: '/ɑ̃tɑ̃dr/',
    type: 'v.t.',
    translation: '听见',
    commonMeanings: ['听见'],
    example: 'Entendre un bruit.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'entente',
        type: 'n.f.',
        meaning: '协议/默契',
        usage: 'Une bonne entente.',
        example: 'Une bonne entente.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 90,
    word: 'entourer',
    phonetic: '/ɑ̃ture/',
    type: 'v.t.',
    translation: '围住',
    commonMeanings: ['围住'],
    example: "Entourer le jardin d'un mur.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'entourage',
        type: 'n.m.',
        meaning: '周围人',
        usage: 'Son proche entourage.',
        example: 'Son proche entourage.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 91,
    word: 'entraîner',
    phonetic: '/ɑ̃trɛne/',
    type: 'v.t.',
    translation: '训练；导致',
    commonMeanings: ['训练', '导致'],
    example: 'Entraîner une équipe.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'entraînement',
        type: 'n.m.',
        meaning: '训练',
        usage: 'Un entraînement quotidien.',
        example: 'Un entraînement quotidien.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 92,
    word: 'entreprendre',
    phonetic: '/ɑ̃trəprɑ̃dr/',
    type: 'v.t.',
    translation: '着手；进行',
    commonMeanings: ['着手', '进行'],
    example: 'Entreprendre des réformes.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'entreprise',
        type: 'n.f.',
        meaning: '企业',
        usage: 'Diriger une entreprise.',
        example: 'Diriger une entreprise.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 93,
    word: 'entretenir',
    phonetic: '/ɑ̃trətnir/',
    type: 'v.t.',
    translation: '维持；保养',
    commonMeanings: ['维持', '保养'],
    example: 'Entretenir la maison.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'entretien',
        type: 'n.m.',
        meaning: '面试/保养',
        usage: "Un entretien d'embauche.",
        example: "Un entretien d'embauche.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 94,
    word: 'envahir',
    phonetic: '/ɑ̃vazir/',
    type: 'v.t.',
    translation: '侵略；充满',
    commonMeanings: ['侵略', '充满'],
    example: 'La foule envahit la rue.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'envahisseur',
        type: 'n.m.',
        meaning: '侵略者',
        usage: "Repousser l'envahisseur.",
        example: "Repousser l'envahisseur.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 95,
    word: 'envisager',
    phonetic: '/ɑ̃vizaʒe/',
    type: 'v.t.',
    translation: '展望；考虑',
    commonMeanings: ['展望', '考虑'],
    example: "Envisager l'avenir.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'visage',
        type: 'n.m.',
        meaning: '脸',
        usage: 'Un beau visage.',
        example: 'Un beau visage.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 96,
    word: 'envoyer',
    phonetic: '/ɑ̃vwaje/',
    type: 'v.t.',
    translation: '发送',
    commonMeanings: ['发送'],
    example: 'Envoyer un e-mail.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'envoi',
        type: 'n.m.',
        meaning: '寄发',
        usage: 'Un envoi par la poste.',
        example: 'Un envoi par la poste.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 97,
    word: 'espérer',
    phonetic: '/ɛspere/',
    type: 'v.t.',
    translation: '希望',
    commonMeanings: ['希望'],
    example: "J'espère qu'il viendra.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'espoir',
        type: 'n.m.',
        meaning: '希望',
        usage: "Garder l'espoir.",
        example: "Garder l'espoir.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 98,
    word: 'essayer',
    phonetic: '/eseje/',
    type: 'v.t.',
    translation: '尝试',
    commonMeanings: ['尝试'],
    example: 'Essayer une robe.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'essai',
        type: 'n.m.',
        meaning: '尝试/试验',
        usage: 'Faire un essai.',
        example: 'Faire un essai.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 99,
    word: 'établir',
    phonetic: '/etablir/',
    type: 'v.t.',
    translation: '建立',
    commonMeanings: ['建立'],
    example: 'Établir un record.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'établissement',
        type: 'n.m.',
        meaning: '机构',
        usage: 'Un établissement public.',
        example: 'Un établissement public.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 100,
    word: 'éteindre',
    phonetic: '/etɛ̃dr/',
    type: 'v.t.',
    translation: '关(灯)；熄灭',
    commonMeanings: ['关(灯)', '熄灭'],
    example: 'Éteindre la lumière.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'extinction',
        type: 'n.f.',
        meaning: '熄灭/绝种',
        usage: "L'extinction des feux.",
        example: "L'extinction des feux.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 101,
    word: 'étendre',
    phonetic: '/etɑ̃dr/',
    type: 'v.t.',
    translation: '铺开；扩大',
    commonMeanings: ['铺开', '扩大'],
    example: 'Étendre le linge.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'étendue',
        type: 'n.f.',
        meaning: '范围/广度',
        usage: 'Une vaste étendue.',
        example: 'Une vaste étendue.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 102,
    word: 'étonner',
    phonetic: '/etɔne/',
    type: 'v.t.',
    translation: '使惊讶',
    commonMeanings: ['使惊讶'],
    example: "Cela m'étonne beaucoup.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'étonnement',
        type: 'n.m.',
        meaning: '惊讶',
        usage: 'À mon grand étonnement.',
        example: 'À mon grand étonnement.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 103,
    word: 'étudier',
    phonetic: '/etydje/',
    type: 'v.t.',
    translation: '学习；研究',
    commonMeanings: ['学习', '研究'],
    example: 'Étudier la médecine.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'étude',
        type: 'n.f.',
        meaning: '学习/研究',
        usage: 'Faire des études.',
        example: 'Faire des études.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 104,
    word: 'éviter',
    phonetic: '/evite/',
    type: 'v.t.',
    translation: '避免',
    commonMeanings: ['避免'],
    example: 'Éviter les fautes.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'évitement',
        type: 'n.m.',
        meaning: '避开',
        usage: "Une stratégie d'évitement.",
        example: "Une stratégie d'évitement.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 105,
    word: 'évoluer',
    phonetic: '/evɔlɥe/',
    type: 'v.i.',
    translation: '进化；演变',
    commonMeanings: ['进化', '演变'],
    example: 'La situation évolue.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'évolution',
        type: 'n.f.',
        meaning: '进化',
        usage: "L'évolution de l'homme.",
        example: "L'évolution de l'homme.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 106,
    word: 'exagérer',
    phonetic: '/ɛɡzaʒere/',
    type: 'v.t.',
    translation: '夸张',
    commonMeanings: ['夸张'],
    example: 'Tu exagères toujours !',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'exagération',
        type: 'n.f.',
        meaning: '夸大',
        usage: "C'est une exagération.",
        example: "C'est une exagération.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 107,
    word: 'examiner',
    phonetic: '/ɛɡzamine/',
    type: 'v.t.',
    translation: '检查；考试',
    commonMeanings: ['检查', '考试'],
    example: 'Examiner un patient.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'examen',
        type: 'n.m.',
        meaning: '考试/检查',
        usage: 'Passer un examen.',
        example: 'Passer un examen.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 108,
    word: 'exiger',
    phonetic: '/ɛɡziʒe/',
    type: 'v.t.',
    translation: '要求',
    commonMeanings: ['要求'],
    example: 'Exiger le silence.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'exigence',
        type: 'n.f.',
        meaning: '要求',
        usage: 'Les exigences du métier.',
        example: 'Les exigences du métier.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 109,
    word: 'exister',
    phonetic: '/ɛɡziste/',
    type: 'v.i.',
    translation: '存在',
    commonMeanings: ['存在'],
    example: "Le Père Noël n'existe pas.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'existence',
        type: 'n.f.',
        meaning: '存在',
        usage: 'Une existence paisible.',
        example: 'Une existence paisible.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 110,
    word: 'expliquer',
    phonetic: '/ɛksplike/',
    type: 'v.t.',
    translation: '解释',
    commonMeanings: ['解释'],
    example: 'Expliquer une règle.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'explication',
        type: 'n.f.',
        meaning: '解释',
        usage: 'Demander des explications.',
        example: 'Demander des explications.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 111,
    word: 'exprimer',
    phonetic: '/ɛksprime/',
    type: 'v.t.',
    translation: '表达',
    commonMeanings: ['表达'],
    example: 'Exprimer sa joie.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'expression',
        type: 'n.f.',
        meaning: '表达/词语',
        usage: 'Une expression idiomatique.',
        example: 'Une expression idiomatique.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 112,
    word: 'fabriquer',
    phonetic: '/fabrike/',
    type: 'v.t.',
    translation: '制造',
    commonMeanings: ['制造'],
    example: 'Fabriquer des jouets.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'fabricant',
        type: 'n.m.',
        meaning: '制造商',
        usage: 'Un fabricant de meubles.',
        example: 'Un fabricant de meubles.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 113,
    word: 'se fâcher',
    phonetic: '/sə faʃe/',
    type: 'v.pr.',
    translation: '生气',
    commonMeanings: ['生气'],
    example: 'Ne te fâche pas !',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'fâché',
        type: 'adj.',
        meaning: '生气的',
        usage: 'Il est fâché contre moi.',
        example: 'Il est fâché contre moi.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 114,
    word: 'faillir',
    phonetic: '/fajir/',
    type: 'v.i.',
    translation: '差点儿；失败',
    commonMeanings: ['差点儿', '失败'],
    example: "J'ai failli tomber.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'faillite',
        type: 'n.f.',
        meaning: '破产',
        usage: 'Faire faillite.',
        example: 'Faire faillite.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 115,
    word: 'falloir',
    phonetic: '/falwar/',
    type: 'v.imp.',
    translation: '必须',
    commonMeanings: ['必须'],
    example: 'Il faut partir.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'faute',
        type: 'n.f.',
        meaning: '错误',
        usage: "C'est ma faute.",
        example: "C'est ma faute.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 116,
    word: 'féliciter',
    phonetic: '/felisite/',
    type: 'v.t.',
    translation: '祝贺',
    commonMeanings: ['祝贺'],
    example: 'Féliciter un ami.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'félicitation',
        type: 'n.f.',
        meaning: '祝贺',
        usage: 'Toutes mes félicitations !',
        example: 'Toutes mes félicitations !',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 117,
    word: 'fermer',
    phonetic: '/fɛrme/',
    type: 'v.t.',
    translation: '关闭',
    commonMeanings: ['关闭'],
    example: 'Fermer la porte.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'fermeture',
        type: 'n.f.',
        meaning: '关闭/拉链',
        usage: 'La fermeture éclair.',
        example: 'La fermeture éclair.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 118,
    word: 'fêter',
    phonetic: '/fɛte/',
    type: 'v.t.',
    translation: '庆祝',
    commonMeanings: ['庆祝'],
    example: 'Fêter son anniversaire.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'fête',
        type: 'n.f.',
        meaning: '节日',
        usage: 'Bonne fête !',
        example: 'Bonne fête !',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 119,
    word: 'figurer',
    phonetic: '/fiɡyre/',
    type: 'v.i./v.pr.',
    translation: '出现；想象',
    commonMeanings: ['出现', '想象'],
    example: 'Figurer sur une liste.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'figurine',
        type: 'n.f.',
        meaning: '小雕像',
        usage: 'Une figurine en porcelaine.',
        example: 'Une figurine en porcelaine.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 120,
    word: 'fixer',
    phonetic: '/fikse/',
    type: 'v.t.',
    translation: '固定；注视',
    commonMeanings: ['固定', '注视'],
    example: 'Fixer un rendez-vous.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'fixe',
        type: 'adj.',
        meaning: '固定的',
        usage: 'Un poste fixe.',
        example: 'Un poste fixe.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 121,
    word: 'flatter',
    phonetic: '/flate/',
    type: 'v.t.',
    translation: '奉承；使高兴',
    commonMeanings: ['奉承', '使高兴'],
    example: 'Flatter son patron.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'flatterie',
        type: 'n.f.',
        meaning: '奉承',
        usage: "Je n'aime pas la flatterie.",
        example: "Je n'aime pas la flatterie.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 122,
    word: 'fleurir',
    phonetic: '/flœrir/',
    type: 'v.i.',
    translation: '开花；繁荣',
    commonMeanings: ['开花', '繁荣'],
    example: 'Les roses fleurissent.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'fleuriste',
        type: 'n.m./f.',
        meaning: '花店老板',
        usage: 'Aller chez le fleuriste.',
        example: 'Aller chez le fleuriste.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 123,
    word: 'forcer',
    phonetic: '/fɔrse/',
    type: 'v.t.',
    translation: '强迫',
    commonMeanings: ['强迫'],
    example: 'Forcer la serrure.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'force',
        type: 'n.f.',
        meaning: '力量',
        usage: 'Utiliser la force.',
        example: 'Utiliser la force.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 124,
    word: 'former',
    phonetic: '/fɔrme/',
    type: 'v.t.',
    translation: '形成；培训',
    commonMeanings: ['形成', '培训'],
    example: 'Former des jeunes.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'formation',
        type: 'n.f.',
        meaning: '培训/形成',
        usage: 'Suivre une formation.',
        example: 'Suivre une formation.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 125,
    word: 'fournir',
    phonetic: '/furnir/',
    type: 'v.t.',
    translation: '提供',
    commonMeanings: ['提供'],
    example: 'Fournir des preuves.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'fournisseur',
        type: 'n.m.',
        meaning: '供应商',
        usage: "Un fournisseur d'accès.",
        example: "Un fournisseur d'accès.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 126,
    word: 'frapper',
    phonetic: '/frape/',
    type: 'v.t.',
    translation: '敲；打',
    commonMeanings: ['敲', '打'],
    example: 'Frapper à la porte.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'frappant',
        type: 'adj.',
        meaning: '显著的',
        usage: 'Un exemple frappant.',
        example: 'Un exemple frappant.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 127,
    word: 'frémir',
    phonetic: '/fremir/',
    type: 'v.i.',
    translation: '战栗',
    commonMeanings: ['战栗'],
    example: 'Frémir de peur.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'frémissement',
        type: 'n.m.',
        meaning: '颤动',
        usage: 'Un léger frémissement.',
        example: 'Un léger frémissement.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 128,
    word: 'fuir',
    phonetic: '/fɥir/',
    type: 'v.t./v.i.',
    translation: '逃避；漏',
    commonMeanings: ['逃避', '漏'],
    example: 'Fuir la réalité.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'fuite',
        type: 'n.f.',
        meaning: '逃跑/漏水',
        usage: "Une fuite d'eau.",
        example: "Une fuite d'eau.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 129,
    word: 'fumer',
    phonetic: '/fyme/',
    type: 'v.t./v.i.',
    translation: '抽烟；冒烟',
    commonMeanings: ['抽烟', '冒烟'],
    example: 'Fumer une cigarette.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'fumée',
        type: 'n.f.',
        meaning: '烟',
        usage: "Il n'y a pas de fumée sans feu.",
        example: "Il n'y a pas de fumée sans feu.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 130,
    word: 'gagner',
    phonetic: '/ɡaɲe/',
    type: 'v.t.',
    translation: '赢得；挣钱',
    commonMeanings: ['赢得', '挣钱'],
    example: 'Gagner un match.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'gagnant',
        type: 'n.m.',
        meaning: '赢家',
        usage: 'Le gagnant du loto.',
        example: 'Le gagnant du loto.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 131,
    word: 'garder',
    phonetic: '/ɡarde/',
    type: 'v.t.',
    translation: '保持；看守',
    commonMeanings: ['保持', '看守'],
    example: 'Garder le silence.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'gardien',
        type: 'n.m.',
        meaning: '看门人/门将',
        usage: 'Le gardien de but.',
        example: 'Le gardien de but.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 132,
    word: 'gaspiller',
    phonetic: '/ɡaspije/',
    type: 'v.t.',
    translation: '浪费',
    commonMeanings: ['浪费'],
    example: 'Gaspiller son temps.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'gaspillage',
        type: 'n.m.',
        meaning: '浪费',
        usage: 'Le gaspillage alimentaire.',
        example: 'Le gaspillage alimentaire.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 133,
    word: 'gâter',
    phonetic: '/ɡate/',
    type: 'v.t.',
    translation: '宠坏；弄坏',
    commonMeanings: ['宠坏', '弄坏'],
    example: 'Gâter un enfant.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'gâteau',
        type: 'n.m.',
        meaning: '蛋糕',
        usage: 'Manger un gâteau.',
        example: 'Manger un gâteau.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 134,
    word: 'gêner',
    phonetic: '/ʒene/',
    type: 'v.t.',
    translation: '妨碍；使尴尬',
    commonMeanings: ['妨碍', '使尴尬'],
    example: 'Cela me gêne.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'gêne',
        type: 'n.f.',
        meaning: '尴尬/不适',
        usage: 'Éprouver de la gêne.',
        example: 'Éprouver de la gêne.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 135,
    word: 'gérer',
    phonetic: '/ʒere/',
    type: 'v.t.',
    translation: '管理',
    commonMeanings: ['管理'],
    example: 'Gérer une crise.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'gestion',
        type: 'n.f.',
        meaning: '管理',
        usage: 'La gestion du temps.',
        example: 'La gestion du temps.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 136,
    word: 'goûter',
    phonetic: '/ɡute/',
    type: 'v.t.',
    translation: '品尝',
    commonMeanings: ['品尝'],
    example: 'Goûter un vin.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'goût',
        type: 'n.m.',
        meaning: '味道/品味',
        usage: 'Chacun ses goûts.',
        example: 'Chacun ses goûts.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 137,
    word: 'gouverner',
    phonetic: '/ɡuvɛrne/',
    type: 'v.t.',
    translation: '统治；治理',
    commonMeanings: ['统治', '治理'],
    example: 'Gouverner un pays.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'gouvernement',
        type: 'n.m.',
        meaning: '政府',
        usage: 'Le chef du gouvernement.',
        example: 'Le chef du gouvernement.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 138,
    word: 'grimper',
    phonetic: '/ɡrɛ̃pe/',
    type: 'v.i.',
    translation: '攀爬',
    commonMeanings: ['攀爬'],
    example: 'Grimper sur un arbre.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'grimpeur',
        type: 'n.m.',
        meaning: '登山者',
        usage: 'Un excellent grimpeur.',
        example: 'Un excellent grimpeur.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 139,
    word: 'guérir',
    phonetic: '/ɡerir/',
    type: 'v.t./v.i.',
    translation: '治愈；痊愈',
    commonMeanings: ['治愈', '痊愈'],
    example: "Guérir d'une maladie.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'guérison',
        type: 'n.f.',
        meaning: '痊愈',
        usage: 'Une guérison miraculeuse.',
        example: 'Une guérison miraculeuse.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 140,
    word: "s'habiller",
    phonetic: '/sabije/',
    type: 'v.pr.',
    translation: '穿衣',
    commonMeanings: ['穿衣'],
    example: "S'habiller chaudement.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'habit',
        type: 'n.m.',
        meaning: '衣服',
        usage: "L'habit ne fait pas le moine.",
        example: "L'habit ne fait pas le moine.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 141,
    word: 'habiter',
    phonetic: '/abite/',
    type: 'v.t./v.i.',
    translation: '居住',
    commonMeanings: ['居住'],
    example: "J'habite à Pékin.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'habitant',
        type: 'n.m.',
        meaning: '居民',
        usage: 'Les habitants de la ville.',
        example: 'Les habitants de la ville.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 142,
    word: "s'habituer",
    phonetic: '/sabitye/',
    type: 'v.pr.',
    translation: '习惯于',
    commonMeanings: ['习惯于'],
    example: "S'habituer au climat.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'habitude',
        type: 'n.f.',
        meaning: '习惯',
        usage: 'Prendre une habitude.',
        example: 'Prendre une habitude.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 143,
    word: 'haïr',
    phonetic: '/air/',
    type: 'v.t.',
    translation: '仇恨',
    commonMeanings: ['仇恨'],
    example: 'Je hais le mensonge.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'haine',
        type: 'n.f.',
        meaning: '仇恨',
        usage: 'Éprouver de la haine.',
        example: 'Éprouver de la haine.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 144,
    word: 'harceler',
    phonetic: '/arsəle/',
    type: 'v.t.',
    translation: '纠缠/骚扰',
    commonMeanings: ['纠缠/骚扰'],
    example: 'Harceler un collègue.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'harcèlement',
        type: 'n.m.',
        meaning: '骚扰',
        usage: 'Le harcèlement moral.',
        example: 'Le harcèlement moral.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 145,
    word: 'hasarder',
    phonetic: '/azarde/',
    type: 'v.t.',
    translation: '冒险',
    commonMeanings: ['冒险'],
    example: 'Hasarder une réponse.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'hasard',
        type: 'n.m.',
        meaning: '偶然/运气',
        usage: 'Par hasard.',
        example: 'Par hasard.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 146,
    word: 'hésiter',
    phonetic: '/ezite/',
    type: 'v.i.',
    translation: '犹豫',
    commonMeanings: ['犹豫'],
    example: "N'hésitez pas à poser des questions.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'hésitation',
        type: 'n.f.',
        meaning: '犹豫',
        usage: 'Sans hésitation.',
        example: 'Sans hésitation.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 147,
    word: 'honorer',
    phonetic: '/ɔnɔme/',
    type: 'v.t.',
    translation: '尊敬/感到光荣',
    commonMeanings: ['尊敬/感到光荣'],
    example: 'Honorer ses parents.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'honneur',
        type: 'n.m.',
        meaning: '荣誉',
        usage: "C'est un grand honneur.",
        example: "C'est un grand honneur.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 148,
    word: 'humilier',
    phonetic: '/ymilje/',
    type: 'v.t.',
    translation: '羞辱',
    commonMeanings: ['羞辱'],
    example: 'Humilier son adversaire.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'humiliation',
        type: 'n.f.',
        meaning: '耻辱',
        usage: 'Subir une humiliation.',
        example: 'Subir une humiliation.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 149,
    word: 'hurler',
    phonetic: '/yrle/',
    type: 'v.i.',
    translation: '嚎叫/吼叫',
    commonMeanings: ['嚎叫/吼叫'],
    example: 'Hurler de douleur.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'hurlement',
        type: 'n.m.',
        meaning: '呐喊',
        usage: 'Des hurlements de joie.',
        example: 'Des hurlements de joie.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 150,
    word: 'identifier',
    phonetic: '/idɑ̃tifje/',
    type: 'v.t.',
    translation: '识别/鉴定',
    commonMeanings: ['识别/鉴定'],
    example: 'Identifier un suspect.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'identité',
        type: 'n.f.',
        meaning: '身份',
        usage: "Carte d'identité.",
        example: "Carte d'identité.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 151,
    word: 'ignorer',
    phonetic: '/iɲɔme/',
    type: 'v.t.',
    translation: '不知道/不理睬',
    commonMeanings: ['不知道/不理睬'],
    example: "J'ignore son adresse.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'ignorant',
        type: 'adj./n.',
        meaning: '无知的',
        usage: 'Il est très ignorant.',
        example: 'Il est très ignorant.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 152,
    word: 'illustrer',
    phonetic: '/ilystre/',
    type: 'v.t.',
    translation: '说明/阐述',
    commonMeanings: ['说明/阐述'],
    example: 'Illustrer un propos.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'illustration',
        type: 'n.f.',
        meaning: '插图/说明',
        usage: 'Une belle illustration.',
        example: 'Une belle illustration.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 153,
    word: 'imaginer',
    phonetic: '/imaʒine/',
    type: 'v.t.',
    translation: '想象',
    commonMeanings: ['想象'],
    example: 'Imaginer une solution.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'imagination',
        type: 'n.f.',
        meaning: '想象力',
        usage: "Avoir de l'imagination.",
        example: "Avoir de l'imagination.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 154,
    word: 'imiter',
    phonetic: '/imite/',
    type: 'v.t.',
    translation: '模仿',
    commonMeanings: ['模仿'],
    example: 'Imiter un accent.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'imitation',
        type: 'n.f.',
        meaning: '模仿',
        usage: 'Une mauvaise imitation.',
        example: 'Une mauvaise imitation.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 155,
    word: 'imposer',
    phonetic: '/ɛ̃poze/',
    type: 'v.t.',
    translation: '强加/征税',
    commonMeanings: ['强加/征税'],
    example: 'Imposer sa volonté.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'impôt',
        type: 'n.m.',
        meaning: '税',
        usage: 'Payer ses impôts.',
        example: 'Payer ses impôts.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 156,
    word: 'impressionner',
    phonetic: '/ɛ̃prɛsjɔne/',
    type: 'v.t.',
    translation: '给...留下印象',
    commonMeanings: ['给...留下印象'],
    example: "Ce film m'a impressionné.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'impression',
        type: 'n.f.',
        meaning: '印象',
        usage: 'Faire bonne impression.',
        example: 'Faire bonne impression.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 157,
    word: 'imprimer',
    phonetic: '/ɛ̃prime/',
    type: 'v.t.',
    translation: '打印/印染',
    commonMeanings: ['打印/印染'],
    example: 'Imprimer un document.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'imprimante',
        type: 'n.f.',
        meaning: '打印机',
        usage: 'Une imprimante laser.',
        example: 'Une imprimante laser.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 158,
    word: 'indiquer',
    phonetic: '/ɛ̃dike/',
    type: 'v.t.',
    translation: '指出/指示',
    commonMeanings: ['指出/指示'],
    example: 'Indiquer le chemin.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'indication',
        type: 'n.f.',
        meaning: '指示/迹象',
        usage: 'Suivre les indications.',
        example: 'Suivre les indications.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 159,
    word: 'informer',
    phonetic: '/ɛ̃fɔrme/',
    type: 'v.t.',
    translation: '通知/告知',
    commonMeanings: ['通知/告知'],
    example: 'Informer le public.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'information',
        type: 'n.f.',
        meaning: '信息/新闻',
        usage: 'Chercher des informations.',
        example: 'Chercher des informations.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 160,
    word: 'inquiéter',
    phonetic: '/ɛ̃kjete/',
    type: 'v.t./v.pr.',
    translation: '使担心/焦虑',
    commonMeanings: ['使担心/焦虑'],
    example: "Cela m'inquiète.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'inquiétude',
        type: 'n.f.',
        meaning: '担忧',
        usage: "Éprouver de l'inquiétude.",
        example: "Éprouver de l'inquiétude.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 161,
    word: 'insister',
    phonetic: '/ɛ̃siste/',
    type: 'v.i.',
    translation: '坚持/强调',
    commonMeanings: ['坚持/强调'],
    example: 'Insister sur un point.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'insistance',
        type: 'n.f.',
        meaning: '坚持',
        usage: 'Avec insistance.',
        example: 'Avec insistance.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 162,
    word: 'installer',
    phonetic: '/ɛ̃stale/',
    type: 'v.t./v.pr.',
    translation: '安装/安置',
    commonMeanings: ['安装/安置'],
    example: 'Installer un logiciel.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'installation',
        type: 'n.f.',
        meaning: '设备/安装',
        usage: "L'installation électrique.",
        example: "L'installation électrique.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 163,
    word: 'interdire',
    phonetic: '/ɛ̃tɛrdir/',
    type: 'v.t.',
    translation: '禁止',
    commonMeanings: ['禁止'],
    example: 'Interdire de fumer.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'interdiction',
        type: 'n.f.',
        meaning: '禁止',
        usage: 'Une interdiction formelle.',
        example: 'Une interdiction formelle.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 164,
    word: 'intéresser',
    phonetic: '/ɛ̃terese/',
    type: 'v.t./v.pr.',
    translation: '使感兴趣',
    commonMeanings: ['使感兴趣'],
    example: "S'intéresser à l'art.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'intérêt',
        type: 'n.m.',
        meaning: '兴趣/利益',
        usage: 'Porter un intérêt à.',
        example: 'Porter un intérêt à.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 165,
    word: 'interrompre',
    phonetic: '/ɛ̃terɔ̃pr/',
    type: 'v.t.',
    translation: '打断/中断',
    commonMeanings: ['打断/中断'],
    example: 'Interrompre un discours.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'interruption',
        type: 'n.f.',
        meaning: '中断',
        usage: 'Sans interruption.',
        example: 'Sans interruption.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 166,
    word: 'inventer',
    phonetic: '/ɛ̃vɑ̃te/',
    type: 'v.t.',
    translation: '发明/虚构',
    commonMeanings: ['发明/虚构'],
    example: 'Inventer une machine.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'invention',
        type: 'n.f.',
        meaning: '发明',
        usage: 'Une invention utile.',
        example: 'Une invention utile.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 167,
    word: 'inviter',
    phonetic: '/ɛ̃vite/',
    type: 'v.t.',
    translation: '邀请',
    commonMeanings: ['邀请'],
    example: 'Inviter des amis.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'invitation',
        type: 'n.f.',
        meaning: '邀请',
        usage: 'Accepter une invitation.',
        example: 'Accepter une invitation.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 168,
    word: 'jeter',
    phonetic: '/ʒəte/',
    type: 'v.t.',
    translation: '扔/投',
    commonMeanings: ['扔/投'],
    example: "Jeter un coup d'œil.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'jet',
        type: 'n.m.',
        meaning: '投掷/喷气',
        usage: "Un jet d'eau.",
        example: "Un jet d'eau.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 169,
    word: 'jouer',
    phonetic: '/ʒwe/',
    type: 'v.t./v.i.',
    translation: '玩/演奏',
    commonMeanings: ['玩/演奏'],
    example: 'Jouer du piano.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'joueur',
        type: 'n.m.',
        meaning: '玩家/运动员',
        usage: 'Un joueur de football.',
        example: 'Un joueur de football.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 170,
    word: 'juger',
    phonetic: '/ʒyʒe/',
    type: 'v.t.',
    translation: '判断/审判',
    commonMeanings: ['判断/审判'],
    example: 'Juger sur les faits.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'jugement',
        type: 'n.m.',
        meaning: '判断/判决',
        usage: 'Porter un jugement.',
        example: 'Porter un jugement.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 171,
    word: 'lancer',
    phonetic: '/lɑ̃se/',
    type: 'v.t.',
    translation: '投掷；发动',
    commonMeanings: ['投掷', '发动'],
    example: 'Lancer un nouveau produit.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'lancement',
        type: 'n.m.',
        meaning: '发行/投放',
        usage: "Le lancement d'un satellite.",
        example: "Le lancement d'un satellite.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 172,
    word: 'lever',
    phonetic: '/ləve/',
    type: 'v.t./v.pr.',
    translation: '举起；起床',
    commonMeanings: ['举起', '起床'],
    example: "Le soleil se lève à l'est.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'lever',
        type: 'n.m.',
        meaning: '日出/起床',
        usage: 'Au lever du jour.',
        example: 'Au lever du jour.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 173,
    word: 'lier',
    phonetic: '/lje/',
    type: 'v.t.',
    translation: '捆绑；联系',
    commonMeanings: ['捆绑', '联系'],
    example: "Lier amitié avec quelqu'un.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'lien',
        type: 'n.m.',
        meaning: '联系/纽带',
        usage: 'Créer des liens sociaux.',
        example: 'Créer des liens sociaux.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 174,
    word: 'limiter',
    phonetic: '/limite/',
    type: 'v.t.',
    translation: '限制',
    commonMeanings: ['限制'],
    example: 'Limiter la vitesse.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'limite',
        type: 'n.f.',
        meaning: '界限',
        usage: 'Dépasser la limite.',
        example: 'Dépasser la limite.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 175,
    word: 'lire',
    phonetic: '/lir/',
    type: 'v.t.',
    translation: '读',
    commonMeanings: ['读'],
    example: 'Lire un journal.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'lecture',
        type: 'n.f.',
        meaning: '阅读',
        usage: 'Une lecture intéressante.',
        example: 'Une lecture intéressante.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 176,
    word: 'loger',
    phonetic: '/lɔʒe/',
    type: 'v.t./v.i.',
    translation: '住宿；安置',
    commonMeanings: ['住宿', '安置'],
    example: "Loger chez l'habitant.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'logement',
        type: 'n.m.',
        meaning: '住房',
        usage: 'Chercher un logement.',
        example: 'Chercher un logement.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 177,
    word: 'louer',
    phonetic: '/lwe/',
    type: 'v.t.',
    translation: '租用；称赞',
    commonMeanings: ['租用', '称赞'],
    example: 'Louer un appartement.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'location',
        type: 'n.f.',
        meaning: '租赁',
        usage: 'Une voiture de location.',
        example: 'Une voiture de location.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 178,
    word: 'lutter',
    phonetic: '/lyte/',
    type: 'v.i.',
    translation: '斗争',
    commonMeanings: ['斗争'],
    example: 'Lutter contre la pauvreté.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'lutte',
        type: 'n.f.',
        meaning: '斗争',
        usage: 'La lutte des classes.',
        example: 'La lutte des classes.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 179,
    word: 'maintenir',
    phonetic: '/mɛ̃tnir/',
    type: 'v.t.',
    translation: '维持',
    commonMeanings: ['维持'],
    example: "Maintenir l'ordre.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'maintien',
        type: 'n.m.',
        meaning: '维持/姿态',
        usage: 'Le maintien de la paix.',
        example: 'Le maintien de la paix.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 180,
    word: 'manger',
    phonetic: '/mɑ̃ʒe/',
    type: 'v.t.',
    translation: '吃',
    commonMeanings: ['吃'],
    example: 'Manger à sa faim.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'mangeable',
        type: 'adj.',
        meaning: '可食用的',
        usage: "Ce n'est pas mangeable.",
        example: "Ce n'est pas mangeable.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 181,
    word: 'manquer',
    phonetic: '/mɑ̃ke/',
    type: 'v.t./v.i.',
    translation: '错过；缺乏',
    commonMeanings: ['错过', '缺乏'],
    example: 'Manquer le train.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'manque',
        type: 'n.m.',
        meaning: '缺乏',
        usage: "Un manque d'argent.",
        example: "Un manque d'argent.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 182,
    word: 'marcher',
    phonetic: '/marʃe/',
    type: 'v.i.',
    translation: '行走；运转',
    commonMeanings: ['行走', '运转'],
    example: 'Marcher sur le trottoir.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'marche',
        type: 'n.f.',
        meaning: '步行/台阶',
        usage: 'Monter les marches.',
        example: 'Monter les marches.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 183,
    word: 'mener',
    phonetic: '/mne/',
    type: 'v.t.',
    translation: '引导；带领',
    commonMeanings: ['引导', '带领'],
    example: 'Mener une enquête.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'meneur',
        type: 'n.m.',
        meaning: '领袖/带头人',
        usage: 'Le meneur de jeu.',
        example: 'Le meneur de jeu.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 184,
    word: 'mentionner',
    phonetic: '/mɑ̃sjɔne/',
    type: 'v.t.',
    translation: '提到',
    commonMeanings: ['提到'],
    example: 'Mentionner un nom.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'mention',
        type: 'n.f.',
        meaning: '提及/评语',
        usage: 'Avec la mention "Bien".',
        example: 'Avec la mention "Bien".',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 185,
    word: 'mentir',
    phonetic: '/mɑ̃tir/',
    type: 'v.i.',
    translation: '撒谎',
    commonMeanings: ['撒谎'],
    example: 'Mentir à ses parents.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'mensonge',
        type: 'n.m.',
        meaning: '谎言',
        usage: 'Dire un mensonge.',
        example: 'Dire un mensonge.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 186,
    word: 'mériter',
    phonetic: '/merite/',
    type: 'v.t.',
    translation: '值得',
    commonMeanings: ['值得'],
    example: 'Il mérite cette récompense.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'mérite',
        type: 'n.m.',
        meaning: '功绩/优点',
        usage: 'Un homme de mérite.',
        example: 'Un homme de mérite.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 187,
    word: 'mesurer',
    phonetic: '/məzyre/',
    type: 'v.t.',
    translation: '测量',
    commonMeanings: ['测量'],
    example: 'Mesurer la distance.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'mesure',
        type: 'n.f.',
        meaning: '措施/尺寸',
        usage: 'Prendre des mesures.',
        example: 'Prendre des mesures.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 188,
    word: 'mettre',
    phonetic: '/mɛtr/',
    type: 'v.t.',
    translation: '放；穿',
    commonMeanings: ['放', '穿'],
    example: 'Mettre la table.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'remise',
        type: 'n.f.',
        meaning: '递交/折扣',
        usage: 'Faire une remise.',
        example: 'Faire une remise.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 189,
    word: 'monter',
    phonetic: '/mɔ̃te/',
    type: 'v.i./v.t.',
    translation: '上升；登上',
    commonMeanings: ['上升', '登上'],
    example: "Monter dans l'avion.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'montagne',
        type: 'n.f.',
        meaning: '山',
        usage: 'Aller à la montagne.',
        example: 'Aller à la montagne.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 190,
    word: 'montrer',
    phonetic: '/mɔ̃tre/',
    type: 'v.t.',
    translation: '出示；显示',
    commonMeanings: ['出示', '显示'],
    example: 'Montrer son passeport.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'montre',
        type: 'n.f.',
        meaning: '手表',
        usage: 'Une montre suisse.',
        example: 'Une montre suisse.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 191,
    word: 'se moquer',
    phonetic: '/sə mɔke/',
    type: 'v.pr.',
    translation: '嘲笑',
    commonMeanings: ['嘲笑'],
    example: "Se moquer de quelqu'un.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'moquerie',
        type: 'n.f.',
        meaning: '嘲弄',
        usage: "C'est une moquerie.",
        example: "C'est une moquerie.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 192,
    word: 'mourir',
    phonetic: '/murir/',
    type: 'v.i.',
    translation: '死亡',
    commonMeanings: ['死亡'],
    example: 'Mourir de rire.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'mort',
        type: 'n.f./adj.',
        meaning: '死亡',
        usage: 'La mort subite.',
        example: 'La mort subite.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 193,
    word: 'multiplier',
    phonetic: '/myltiplije/',
    type: 'v.t.',
    translation: '增加；乘',
    commonMeanings: ['增加', '乘'],
    example: 'Multiplier les efforts.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'multiplication',
        type: 'n.f.',
        meaning: '乘法',
        usage: 'Faire une multiplication.',
        example: 'Faire une multiplication.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 194,
    word: 'naître',
    phonetic: '/nɛtr/',
    type: 'v.i.',
    translation: '出生',
    commonMeanings: ['出生'],
    example: 'Naître en France.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'naissance',
        type: 'n.f.',
        meaning: '出生',
        usage: 'Lieu de naissance.',
        example: 'Lieu de naissance.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 195,
    word: 'naviguer',
    phonetic: '/naviɡe/',
    type: 'v.i.',
    translation: '航行',
    commonMeanings: ['航行'],
    example: 'Naviguer sur Internet.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'navigateur',
        type: 'n.m.',
        meaning: '航海家/浏览器',
        usage: 'Un grand navigateur.',
        example: 'Un grand navigateur.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 196,
    word: 'négliger',
    phonetic: '/neɡliʒe/',
    type: 'v.t.',
    translation: '疏忽',
    commonMeanings: ['疏忽'],
    example: 'Négliger son travail.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'négligence',
        type: 'n.f.',
        meaning: '粗心',
        usage: 'Par négligence.',
        example: 'Par négligence.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 197,
    word: 'négocier',
    phonetic: '/neɡɔsje/',
    type: 'v.t.',
    translation: '谈判',
    commonMeanings: ['谈判'],
    example: 'Négocier un contrat.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'négociation',
        type: 'n.f.',
        meaning: '谈判',
        usage: 'En pleine négociation.',
        example: 'En pleine négociation.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 198,
    word: 'nettoyer',
    phonetic: '/netwajje/',
    type: 'v.t.',
    translation: '打扫',
    commonMeanings: ['打扫'],
    example: 'Nettoyer la cuisine.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'nettoyage',
        type: 'n.m.',
        meaning: '清洁',
        usage: 'Faire le nettoyage.',
        example: 'Faire le nettoyage.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 199,
    word: 'nommer',
    phonetic: '/nɔme/',
    type: 'v.t.',
    translation: '命名；任命',
    commonMeanings: ['命名', '任命'],
    example: 'Nommer un directeur.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'nomination',
        type: 'n.f.',
        meaning: '任命',
        usage: 'Sa nomination est officielle.',
        example: 'Sa nomination est officielle.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 200,
    word: 'noter',
    phonetic: '/nɔte/',
    type: 'v.t.',
    translation: '记录；打分',
    commonMeanings: ['记录', '打分'],
    example: 'Noter une adresse.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'note',
        type: 'n.f.',
        meaning: '笔记/分数',
        usage: 'Prendre des notes.',
        example: 'Prendre des notes.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 201,
    word: 'nourrir',
    phonetic: '/nurir/',
    type: 'v.t.',
    translation: '喂养；养育',
    commonMeanings: ['喂养', '养育'],
    example: 'Nourrir un animal.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'nourriture',
        type: 'n.f.',
        meaning: '食物',
        usage: 'La nourriture saine.',
        example: 'La nourriture saine.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 202,
    word: 'nuire',
    phonetic: '/nɥir/',
    type: 'v.i.',
    translation: '损害',
    commonMeanings: ['损害'],
    example: 'Cela nuit à la santé.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'nuisible',
        type: 'adj.',
        meaning: '有害的',
        usage: 'Un insecte nuisible.',
        example: 'Un insecte nuisible.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 203,
    word: 'obéir',
    phonetic: '/ɔbeir/',
    type: 'v.i.',
    translation: '服从',
    commonMeanings: ['服从'],
    example: 'Obéir aux ordres.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'obéissance',
        type: 'n.f.',
        meaning: '服从',
        usage: 'Une obéissance aveugle.',
        example: 'Une obéissance aveugle.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 204,
    word: 'obliger',
    phonetic: '/ɔbliʒe/',
    type: 'v.t.',
    translation: '强迫',
    commonMeanings: ['强迫'],
    example: "Obliger quelqu'un à partir.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'obligation',
        type: 'n.f.',
        meaning: '义务',
        usage: 'Une obligation morale.',
        example: 'Une obligation morale.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 205,
    word: 'observer',
    phonetic: '/ɔbsɛrve/',
    type: 'v.t.',
    translation: '观察；遵守',
    commonMeanings: ['观察', '遵守'],
    example: 'Observer les oiseaux.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'observation',
        type: 'n.f.',
        meaning: '观察',
        usage: 'Faire une observation.',
        example: 'Faire une observation.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 206,
    word: 'obtenir',
    phonetic: '/ɔptənir/',
    type: 'v.t.',
    translation: '获得',
    commonMeanings: ['获得'],
    example: 'Obtenir un diplôme.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'obtention',
        type: 'n.f.',
        meaning: '获得',
        usage: "L'obtention d'un visa.",
        example: "L'obtention d'un visa.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 207,
    word: 'occuper',
    phonetic: '/ɔkype/',
    type: 'v.t./v.pr.',
    translation: '占用；照看',
    commonMeanings: ['占用', '照看'],
    example: "S'occuper des enfants.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'occupation',
        type: 'n.f.',
        meaning: '职业/占用',
        usage: 'Une occupation favorite.',
        example: 'Une occupation favorite.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 208,
    word: 'offrir',
    phonetic: '/ɔfrir/',
    type: 'v.t.',
    translation: '提供；赠送',
    commonMeanings: ['提供', '赠送'],
    example: 'Offrir un cadeau.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'offre',
        type: 'n.f.',
        meaning: '提供/报价',
        usage: "L'offre et la demande.",
        example: "L'offre et la demande.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 209,
    word: 'oser',
    phonetic: '/oze/',
    type: 'v.t.',
    translation: '敢于',
    commonMeanings: ['敢于'],
    example: "Il n'ose pas parler.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'osé',
        type: 'adj.',
        meaning: '大胆的',
        usage: 'Une tentative osée.',
        example: 'Une tentative osée.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 210,
    word: 'oublier',
    phonetic: '/ublije/',
    type: 'v.t.',
    translation: '忘记',
    commonMeanings: ['忘记'],
    example: "J'ai oublié mon sac.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'oubli',
        type: 'n.m.',
        meaning: '遗忘',
        usage: "Un moment d'oubli.",
        example: "Un moment d'oubli.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 211,
    word: 'ouvrir',
    phonetic: '/uvrir/',
    type: 'v.t.',
    translation: '打开',
    commonMeanings: ['打开'],
    example: 'Ouvrir la fenêtre.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'ouverture',
        type: 'n.f.',
        meaning: '开启/孔',
        usage: "L'ouverture des jeux.",
        example: "L'ouverture des jeux.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 212,
    word: 'paraître',
    phonetic: '/parɛtr/',
    type: 'v.i.',
    translation: '显得；出版',
    commonMeanings: ['显得', '出版'],
    example: 'Il paraît fatigué.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'parution',
        type: 'n.f.',
        meaning: '出版',
        usage: "La parution d'un livre.",
        example: "La parution d'un livre.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 213,
    word: 'pardonner',
    phonetic: '/pardɔne/',
    type: 'v.t.',
    translation: '原谅',
    commonMeanings: ['原谅'],
    example: 'Pardonner une faute.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'pardon',
        type: 'n.m.',
        meaning: '原谅',
        usage: 'Demander pardon.',
        example: 'Demander pardon.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 214,
    word: 'parcourir',
    phonetic: '/parkurir/',
    type: 'v.t.',
    translation: '遍经；浏览',
    commonMeanings: ['遍经', '浏览'],
    example: 'Parcourir le monde.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'parcours',
        type: 'n.m.',
        meaning: '历程/路线',
        usage: 'Un parcours difficile.',
        example: 'Un parcours difficile.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 215,
    word: 'partager',
    phonetic: '/partaʒe/',
    type: 'v.t.',
    translation: '分享；瓜分',
    commonMeanings: ['分享', '瓜分'],
    example: 'Partager un repas.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'partage',
        type: 'n.m.',
        meaning: '分配',
        usage: 'Le partage des tâches.',
        example: 'Le partage des tâches.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 216,
    word: 'participer',
    phonetic: '/partisipe/',
    type: 'v.i.',
    translation: '参加',
    commonMeanings: ['参加'],
    example: 'Participer à une réunion.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'participation',
        type: 'n.f.',
        meaning: '参加',
        usage: 'Une large participation.',
        example: 'Une large participation.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 217,
    word: 'partir',
    phonetic: '/partir/',
    type: 'v.i.',
    translation: '出发',
    commonMeanings: ['出发'],
    example: 'Partir en vacances.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'départ',
        type: 'n.m.',
        meaning: '出发',
        usage: "L'heure du départ.",
        example: "L'heure du départ.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 218,
    word: 'parvenir',
    phonetic: '/parvənir/',
    type: 'v.i.',
    translation: '到达；成功',
    commonMeanings: ['到达', '成功'],
    example: 'Parvenir à son but.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'parvenu',
        type: 'n.m.',
        meaning: '暴发户',
        usage: 'Un riche parvenu.',
        example: 'Un riche parvenu.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 219,
    word: 'passer',
    phonetic: '/pase/',
    type: 'v.t./v.i.',
    translation: '经过；度过',
    commonMeanings: ['经过', '度过'],
    example: 'Passer un examen.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'passage',
        type: 'n.m.',
        meaning: '经过/通道',
        usage: 'Un passage piéton.',
        example: 'Un passage piéton.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 220,
    word: 'passionner',
    phonetic: '/pasjɔne/',
    type: 'v.t.',
    translation: '使入迷',
    commonMeanings: ['使入迷'],
    example: 'Ce sujet me passionne.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'passion',
        type: 'n.f.',
        meaning: '激情',
        usage: "Une passion pour l'art.",
        example: "Une passion pour l'art.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 221,
    word: 'payer',
    phonetic: '/peje/',
    type: 'v.t.',
    translation: '支付',
    commonMeanings: ['支付'],
    example: 'Payer la facture.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'paiement',
        type: 'n.m.',
        meaning: '支付',
        usage: 'Un paiement en ligne.',
        example: 'Un paiement en ligne.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 222,
    word: 'pêcher',
    phonetic: '/pɛʃe/',
    type: 'v.t./v.i.',
    translation: '钓鱼',
    commonMeanings: ['钓鱼'],
    example: 'Aller pêcher le dimanche.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'pêcheur',
        type: 'n.m.',
        meaning: '渔夫',
        usage: 'Un bateau de pêcheur.',
        example: 'Un bateau de pêcheur.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 223,
    word: 'peindre',
    phonetic: '/pɛ̃dr/',
    type: 'v.t.',
    translation: '绘画',
    commonMeanings: ['绘画'],
    example: 'Peindre un tableau.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'peinture',
        type: 'n.f.',
        meaning: '绘画/油漆',
        usage: 'Un cours de peinture.',
        example: 'Un cours de peinture.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 224,
    word: 'pénétrer',
    phonetic: '/penetre/',
    type: 'v.t./v.i.',
    translation: '进入；渗入',
    commonMeanings: ['进入', '渗入'],
    example: 'Pénétrer dans la salle.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'pénétration',
        type: 'n.f.',
        meaning: '渗入/洞察力',
        usage: "Sa pénétration d'esprit.",
        example: "Sa pénétration d'esprit.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 225,
    word: 'penser',
    phonetic: '/pɑ̃se/',
    type: 'v.t./v.i.',
    translation: '想；认为',
    commonMeanings: ['想', '认为'],
    example: 'Je pense à toi.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'pensée',
        type: 'n.f.',
        meaning: '思想',
        usage: 'Une pensée profonde.',
        example: 'Une pensée profonde.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 226,
    word: 'perdre',
    phonetic: '/pɛrdr/',
    type: 'v.t.',
    translation: '丢失；输',
    commonMeanings: ['丢失', '输'],
    example: 'Perdre ses clés.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'perte',
        type: 'n.f.',
        meaning: '损失',
        usage: 'Une grande perte.',
        example: 'Une grande perte.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 227,
    word: 'permettre',
    phonetic: '/pɛrmɛtr/',
    type: 'v.t.',
    translation: '允许',
    commonMeanings: ['允许'],
    example: 'Permettre de sortir.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'permis',
        type: 'n.m.',
        meaning: '许可/驾照',
        usage: 'Le permis de conduire.',
        example: 'Le permis de conduire.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 228,
    word: 'persuader',
    phonetic: '/pɛrsɥade/',
    type: 'v.t.',
    translation: '说服',
    commonMeanings: ['说服'],
    example: 'Persuader un client.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'persuasion',
        type: 'n.f.',
        meaning: '说服',
        usage: "L'art de la persuasion.",
        example: "L'art de la persuasion.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 229,
    word: 'peser',
    phonetic: '/pəze/',
    type: 'v.t./v.i.',
    translation: '称重；重量为',
    commonMeanings: ['称重', '重量为'],
    example: 'Peser ses bagages.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'poids',
        type: 'n.m.',
        meaning: '重量',
        usage: 'Perdre du poids.',
        example: 'Perdre du poids.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 230,
    word: 'placer',
    phonetic: '/plase/',
    type: 'v.t.',
    translation: '放置；安置',
    commonMeanings: ['放置', '安置'],
    example: 'Placer son argent.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'placement',
        type: 'n.m.',
        meaning: '放置/投资',
        usage: 'Un bon placement.',
        example: 'Un bon placement.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 231,
    word: 'plaindre',
    phonetic: '/plɛ̃dr/',
    type: 'v.t.',
    translation: '可怜；怜悯',
    commonMeanings: ['可怜', '怜悯'],
    example: 'Je plains ces pauvres gens.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'plainte',
        type: 'n.f.',
        meaning: '抱怨/投诉',
        usage: 'Déposer une plainte.',
        example: 'Déposer une plainte.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 232,
    word: 'se plaindre',
    phonetic: '/sə plɛ̃dr/',
    type: 'v.pr.',
    translation: '抱怨；投诉',
    commonMeanings: ['抱怨', '投诉'],
    example: 'Il se plaint du bruit.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'plaintif',
        type: 'adj.',
        meaning: '哀求的',
        usage: 'Une voix plaintive.',
        example: 'Une voix plaintive.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 233,
    word: 'plaire',
    phonetic: '/plɛr/',
    type: 'v.i.',
    translation: '使喜欢',
    commonMeanings: ['使喜欢'],
    example: 'Ce film me plaît beaucoup.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'plaisir',
        type: 'n.m.',
        meaning: '快乐',
        usage: "Faire plaisir à quelqu'un.",
        example: "Faire plaisir à quelqu'un.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 234,
    word: 'plaisanter',
    phonetic: '/plɛzɑ̃te/',
    type: 'v.i.',
    translation: '开玩笑',
    commonMeanings: ['开玩笑'],
    example: "Tu plaisantes, j'espère ?",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'plaisanterie',
        type: 'n.f.',
        meaning: '笑话',
        usage: 'Une mauvaise plaisanterie.',
        example: 'Une mauvaise plaisanterie.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 235,
    word: 'pleurer',
    phonetic: '/plœme/',
    type: 'v.i.',
    translation: '哭',
    commonMeanings: ['哭'],
    example: "L'enfant pleure son jouet.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'pleur',
        type: 'n.m.',
        meaning: '泪水',
        usage: 'Fondre en pleurs.',
        example: 'Fondre en pleurs.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 236,
    word: 'pleuvoir',
    phonetic: '/plœvwar/',
    type: 'v.imp.',
    translation: '下雨',
    commonMeanings: ['下雨'],
    example: 'Il pleut à verse.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'pluie',
        type: 'n.f.',
        meaning: '雨',
        usage: 'Une pluie battante.',
        example: 'Une pluie battante.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 237,
    word: 'plier',
    phonetic: '/plije/',
    type: 'v.t.',
    translation: '折叠；弯曲',
    commonMeanings: ['折叠', '弯曲'],
    example: 'Plier ses vêtements.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'pli',
        type: 'n.m.',
        meaning: '折痕',
        usage: 'Faire un pli.',
        example: 'Faire un pli.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 238,
    word: 'plonger',
    phonetic: '/plɔ̃ʒe/',
    type: 'v.i./v.t.',
    translation: '潜水；浸入',
    commonMeanings: ['潜水', '浸入'],
    example: 'Plonger dans la piscine.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'plongeur',
        type: 'n.m.',
        meaning: '潜水员',
        usage: 'Un plongeur sous-marin.',
        example: 'Un plongeur sous-marin.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 239,
    word: 'porter',
    phonetic: '/pɔrte/',
    type: 'v.t.',
    translation: '拿；穿；带着',
    commonMeanings: ['拿', '穿', '带着'],
    example: 'Porter une valise.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'port',
        type: 'n.m.',
        meaning: '港口/背负',
        usage: "Le port d'armes.",
        example: "Le port d'armes.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 240,
    word: 'poser',
    phonetic: '/poze/',
    type: 'v.t.',
    translation: '放置；提出',
    commonMeanings: ['放置', '提出'],
    example: 'Poser une question.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'position',
        type: 'n.f.',
        meaning: '位置',
        usage: 'Changer de position.',
        example: 'Changer de position.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 241,
    word: 'posséder',
    phonetic: '/pɔsede/',
    type: 'v.t.',
    translation: '拥有',
    commonMeanings: ['拥有'],
    example: 'Il possède une grande fortune.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'possession',
        type: 'n.f.',
        meaning: '拥有',
        usage: 'En possession de.',
        example: 'En possession de.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 242,
    word: 'pousser',
    phonetic: '/puse/',
    type: 'v.t./v.i.',
    translation: '推；生长',
    commonMeanings: ['推', '生长'],
    example: 'Pousser la porte.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'poussée',
        type: 'n.f.',
        meaning: '推动/爆发',
        usage: 'Une poussée de fièvre.',
        example: 'Une poussée de fièvre.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 243,
    word: 'pouvoir',
    phonetic: '/puvwar/',
    type: 'v.mod.',
    translation: '能够',
    commonMeanings: ['能够'],
    example: 'Je peux vous aider.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'pouvoir',
        type: 'n.m.',
        meaning: '权力/能力',
        usage: 'Prendre le pouvoir.',
        example: 'Prendre le pouvoir.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 244,
    word: 'pratiquer',
    phonetic: '/pratike/',
    type: 'v.t.',
    translation: '实践；从事',
    commonMeanings: ['实践', '从事'],
    example: 'Pratiquer un sport.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'pratique',
        type: 'n.f./adj.',
        meaning: '实践/实用的',
        usage: "C'est très pratique.",
        example: "C'est très pratique.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 245,
    word: 'préférer',
    phonetic: '/prefere/',
    type: 'v.t.',
    translation: '更喜欢',
    commonMeanings: ['更喜欢'],
    example: 'Je préfère le café.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'préférence',
        type: 'n.f.',
        meaning: '偏爱',
        usage: 'De préférence.',
        example: 'De préférence.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 246,
    word: 'prendre',
    phonetic: '/prɑ̃dr/',
    type: 'v.t.',
    translation: '拿；吃；乘车',
    commonMeanings: ['拿', '吃', '乘车'],
    example: 'Prendre le métro.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'prise',
        type: 'n.f.',
        meaning: '抓取/插座',
        usage: 'Une prise de courant.',
        example: 'Une prise de courant.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 247,
    word: 'préparer',
    phonetic: '/prepare/',
    type: 'v.t.',
    translation: '准备',
    commonMeanings: ['准备'],
    example: 'Préparer le dîner.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'préparation',
        type: 'n.f.',
        meaning: '准备',
        usage: 'En cours de préparation.',
        example: 'En cours de préparation.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 248,
    word: 'présenter',
    phonetic: '/prezɑ̃te/',
    type: 'v.t.',
    translation: '介绍；呈现',
    commonMeanings: ['介绍', '呈现'],
    example: 'Présenter ses excuses.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'présentation',
        type: 'n.f.',
        meaning: '介绍',
        usage: 'Faire une présentation.',
        example: 'Faire une présentation.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 249,
    word: 'préserver',
    phonetic: '/prezɛrve/',
    type: 'v.t.',
    translation: '保护；保存',
    commonMeanings: ['保护', '保存'],
    example: "Préserver l'environnement.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'préservation',
        type: 'n.f.',
        meaning: '保存',
        usage: 'La préservation des forêts.',
        example: 'La préservation des forêts.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 250,
    word: 'prévenir',
    phonetic: '/prevnir/',
    type: 'v.t.',
    translation: '预防；通知',
    commonMeanings: ['预防', '通知'],
    example: 'Prévenir la police.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'prévention',
        type: 'n.f.',
        meaning: '预防',
        usage: 'La prévention routière.',
        example: 'La prévention routière.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 251,
    word: 'prévoir',
    phonetic: '/prevwar/',
    type: 'v.t.',
    translation: '预见；准备',
    commonMeanings: ['预见', '准备'],
    example: 'Prévoir le temps.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'prévision',
        type: 'n.f.',
        meaning: '预测',
        usage: 'Les prévisions météo.',
        example: 'Les prévisions météo.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 252,
    word: 'prier',
    phonetic: '/prije/',
    type: 'v.t.',
    translation: '请求；祈祷',
    commonMeanings: ['请求', '祈祷'],
    example: "Je vous prie de m'écouter.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'prière',
        type: 'n.f.',
        meaning: '请求/祈祷',
        usage: 'Faire une prière.',
        example: 'Faire une prière.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 253,
    word: 'produire',
    phonetic: '/prɔdɥir/',
    type: 'v.t.',
    translation: '生产；产生',
    commonMeanings: ['生产', '产生'],
    example: "Produire de l'énergie.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'produit',
        type: 'n.m.',
        meaning: '产品',
        usage: 'Un produit local.',
        example: 'Un produit local.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 254,
    word: 'profiter',
    phonetic: '/prɔfite/',
    type: 'v.i.',
    translation: '利用；受益',
    commonMeanings: ['利用', '受益'],
    example: 'Profiter des vacances.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'profit',
        type: 'n.m.',
        meaning: '利润',
        usage: 'Faire du profit.',
        example: 'Faire du profit.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 255,
    word: 'projeter',
    phonetic: '/prɔʒte/',
    type: 'v.t.',
    translation: '投影；计划',
    commonMeanings: ['投影', '计划'],
    example: 'Projeter un film.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'projet',
        type: 'n.m.',
        meaning: '计划/项目',
        usage: 'Un projet de loi.',
        example: 'Un projet de loi.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 256,
    word: 'promettre',
    phonetic: '/prɔmɛtr/',
    type: 'v.t.',
    translation: '答应；承诺',
    commonMeanings: ['答应', '承诺'],
    example: 'Promettre de venir.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'promesse',
        type: 'n.f.',
        meaning: '承诺',
        usage: 'Tenir sa promesse.',
        example: 'Tenir sa promesse.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 257,
    word: 'proposer',
    phonetic: '/prɔpoze/',
    type: 'v.t.',
    translation: '建议；提议',
    commonMeanings: ['建议', '提议'],
    example: 'Proposer une idée.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'proposition',
        type: 'n.f.',
        meaning: '建议',
        usage: 'Faire une proposition.',
        example: 'Faire une proposition.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 258,
    word: 'protéger',
    phonetic: '/prɔteʒe/',
    type: 'v.t.',
    translation: '保护',
    commonMeanings: ['保护'],
    example: 'Protéger la nature.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'protection',
        type: 'n.f.',
        meaning: '保护',
        usage: 'Sous la protection de.',
        example: 'Sous la protection de.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 259,
    word: 'prouver',
    phonetic: '/pruve/',
    type: 'v.t.',
    translation: '证明',
    commonMeanings: ['证明'],
    example: 'Prouver son innocence.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'preuve',
        type: 'n.f.',
        meaning: '证据',
        usage: 'Une preuve accablante.',
        example: 'Une preuve accablante.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 260,
    word: 'publier',
    phonetic: '/pyblije/',
    type: 'v.t.',
    translation: '出版；公布',
    commonMeanings: ['出版', '公布'],
    example: 'Publier un article.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'publication',
        type: 'n.f.',
        meaning: '出版物',
        usage: 'Une nouvelle publication.',
        example: 'Une nouvelle publication.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 261,
    word: 'quitter',
    phonetic: '/kite/',
    type: 'v.t.',
    translation: '离开；放弃',
    commonMeanings: ['离开', '放弃'],
    example: 'Il a quitté la ville.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'quittance',
        type: 'n.f.',
        meaning: '收据',
        usage: 'Demander une quittance.',
        example: 'Demander une quittance.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 262,
    word: 'raconter',
    phonetic: '/rakɔ̃te/',
    type: 'v.t.',
    translation: '讲述',
    commonMeanings: ['讲述'],
    example: 'Raconter une histoire.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'raconteur',
        type: 'n.m.',
        meaning: '讲述者',
        usage: 'Un bon raconteur.',
        example: 'Un bon raconteur.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 263,
    word: 'ralentir',
    phonetic: '/ralɑ̃tir/',
    type: 'v.t./v.i.',
    translation: '放慢',
    commonMeanings: ['放慢'],
    example: "Ralentir à l'approche d'un virage.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'ralentissement',
        type: 'n.m.',
        meaning: '减速',
        usage: 'Un ralentissement économique.',
        example: 'Un ralentissement économique.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 264,
    word: 'ramasser',
    phonetic: '/ramase/',
    type: 'v.t.',
    translation: '拾起；收集',
    commonMeanings: ['拾起', '收集'],
    example: 'Ramasser les copies.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'ramassage',
        type: 'n.m.',
        meaning: '收集/接送',
        usage: 'Le ramassage scolaire.',
        example: 'Le ramassage scolaire.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 265,
    word: 'ramener',
    phonetic: '/ramne/',
    type: 'v.t.',
    translation: '再带回来',
    commonMeanings: ['再带回来'],
    example: 'Ramener un ami chez lui.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'mène',
        type: 'v. (base)',
        meaning: '引导',
        usage: 'Cela nous mène loin.',
        example: 'Cela nous mène loin.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 266,
    word: 'ranger',
    phonetic: '/rɑ̃ʒe/',
    type: 'v.t.',
    translation: '整理；排列',
    commonMeanings: ['整理', '排列'],
    example: 'Ranger sa chambre.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'rangement',
        type: 'n.m.',
        meaning: '整理/储藏',
        usage: 'Un meuble de rangement.',
        example: 'Un meuble de rangement.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 267,
    word: 'rappeler',
    phonetic: '/raple/',
    type: 'v.t.',
    translation: '再叫；使想起',
    commonMeanings: ['再叫', '使想起'],
    example: "Rappeler quelqu'un au téléphone.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'rappel',
        type: 'n.m.',
        meaning: '叫回/提醒',
        usage: 'Un rappel de vaccin.',
        example: 'Un rappel de vaccin.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 268,
    word: 'se rapporter',
    phonetic: '/sə rapɔrte/',
    type: 'v.pr.',
    translation: '关联；有关',
    commonMeanings: ['关联', '有关'],
    example: 'Cela se rapporte à ce sujet.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'rapport',
        type: 'n.m.',
        meaning: '关系/报告',
        usage: 'Faire un rapport.',
        example: 'Faire un rapport.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 269,
    word: 'rassembler',
    phonetic: '/rasɑ̃ble/',
    type: 'v.t.',
    translation: '召集；聚集',
    commonMeanings: ['召集', '聚集'],
    example: 'Rassembler des documents.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'rassemblement',
        type: 'n.m.',
        meaning: '集会',
        usage: 'Un rassemblement politique.',
        example: 'Un rassemblement politique.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 270,
    word: 'rassurer',
    phonetic: '/rasyre/',
    type: 'v.t.',
    translation: '使放心',
    commonMeanings: ['使放心'],
    example: 'Rassurer un enfant.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'rassurant',
        type: 'adj.',
        meaning: '令人放心的',
        usage: 'Une nouvelle rassurante.',
        example: 'Une nouvelle rassurante.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 271,
    word: 'rater',
    phonetic: '/rate/',
    type: 'v.t.',
    translation: '错过；失败',
    commonMeanings: ['错过', '失败'],
    example: 'Rater son train.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'raté',
        type: 'n.m.',
        meaning: '失败者/哑火',
        usage: 'Un film raté.',
        example: 'Un film raté.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 272,
    word: 'réagir',
    phonetic: '/reaʒir/',
    type: 'v.i.',
    translation: '反应',
    commonMeanings: ['反应'],
    example: 'Réagir avec calme.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'réaction',
        type: 'n.f.',
        meaning: '反应',
        usage: 'Une réaction chimique.',
        example: 'Une réaction chimique.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 273,
    word: 'réaliser',
    phonetic: '/realize/',
    type: 'v.t.',
    translation: '实现；制作',
    commonMeanings: ['实现', '制作'],
    example: 'Réaliser un projet.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'réalisation',
        type: 'n.f.',
        meaning: '实现/导演',
        usage: "La réalisation d'un film.",
        example: "La réalisation d'un film.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 274,
    word: 'recevoir',
    phonetic: '/rəsəvwar/',
    type: 'v.t.',
    translation: '收到；接待',
    commonMeanings: ['收到', '接待'],
    example: 'Recevoir une lettre.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'réception',
        type: 'n.f.',
        meaning: '接收/接待',
        usage: 'Accusé de réception.',
        example: 'Accusé de réception.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 275,
    word: 'réchauffer',
    phonetic: '/reʃofe/',
    type: 'v.t.',
    translation: '使变热',
    commonMeanings: ['使变热'],
    example: 'Réchauffer le plat.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'réchauffement',
        type: 'n.m.',
        meaning: '变暖',
        usage: 'Le réchauffement climatique.',
        example: 'Le réchauffement climatique.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 276,
    word: 'rechercher',
    phonetic: '/rəʃɛrʃe/',
    type: 'v.t.',
    translation: '寻找；研究',
    commonMeanings: ['寻找', '研究'],
    example: 'Rechercher la vérité.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'recherche',
        type: 'n.f.',
        meaning: '搜索/科研',
        usage: 'Faire de la recherche.',
        example: 'Faire de la recherche.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 277,
    word: 'réclamer',
    phonetic: '/reklame/',
    type: 'v.t.',
    translation: '要求；抗议',
    commonMeanings: ['要求', '抗议'],
    example: 'Réclamer justice.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'réclamation',
        type: 'n.f.',
        meaning: '投诉/要求',
        usage: 'Faire une réclamation.',
        example: 'Faire une réclamation.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 278,
    word: 'récolter',
    phonetic: '/rekɔlte/',
    type: 'v.t.',
    translation: '收割；收获',
    commonMeanings: ['收割', '收获'],
    example: 'Récolter le blé.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'récolte',
        type: 'n.f.',
        meaning: '收获',
        usage: 'Une bonne récolte.',
        example: 'Une bonne récolte.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 279,
    word: 'recommander',
    phonetic: '/rəkɔmɑ̃de/',
    type: 'v.t.',
    translation: '推荐；建议',
    commonMeanings: ['推荐', '建议'],
    example: 'Recommander un restaurant.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'recommandation',
        type: 'n.f.',
        meaning: '推荐',
        usage: 'Suivre une recommandation.',
        example: 'Suivre une recommandation.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 280,
    word: 'recommencer',
    phonetic: '/rəkɔmɑ̃se/',
    type: 'v.t.',
    translation: '重新开始',
    commonMeanings: ['重新开始'],
    example: 'Recommencer à zéro.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'commencement',
        type: 'n.m.',
        meaning: '开始',
        usage: 'Au commencement.',
        example: 'Au commencement.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 281,
    word: 'reconnaître',
    phonetic: '/rəkɔnɛtr/',
    type: 'v.t.',
    translation: '认出；承认',
    commonMeanings: ['认出', '承认'],
    example: 'Reconnaître un ami.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'reconnaissance',
        type: 'n.f.',
        meaning: '认出/感激',
        usage: 'Témoigner sa reconnaissance.',
        example: 'Témoigner sa reconnaissance.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 282,
    word: 'récupérer',
    phonetic: '/rekypere/',
    type: 'v.t.',
    translation: '恢复；取回',
    commonMeanings: ['恢复', '取回'],
    example: 'Récupérer ses forces.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'récupération',
        type: 'n.f.',
        meaning: '恢复/回收',
        usage: 'La récupération des déchets.',
        example: 'La récupération des déchets.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 283,
    word: 'rédiger',
    phonetic: '/rediʒe/',
    type: 'v.t.',
    translation: '拟定；撰写',
    commonMeanings: ['拟定', '撰写'],
    example: 'Rédiger un rapport.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'rédaction',
        type: 'n.f.',
        meaning: '写作/编辑部',
        usage: "La rédaction d'un journal.",
        example: "La rédaction d'un journal.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 284,
    word: 'réduire',
    phonetic: '/redɥir/',
    type: 'v.t.',
    translation: '减少',
    commonMeanings: ['减少'],
    example: 'Réduire les dépenses.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'réduction',
        type: 'n.f.',
        meaning: '减少/折扣',
        usage: 'Obtenir une réduction.',
        example: 'Obtenir une réduction.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 285,
    word: 'réfléchir',
    phonetic: '/refleʃir/',
    type: 'v.i.',
    translation: '思考；反射',
    commonMeanings: ['思考', '反射'],
    example: "Réfléchir avant d'agir.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'réflexion',
        type: 'n.f.',
        meaning: '思考/反射',
        usage: 'Mener une réflexion.',
        example: 'Mener une réflexion.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 286,
    word: 'refuser',
    phonetic: '/rəfyze/',
    type: 'v.t.',
    translation: '拒绝',
    commonMeanings: ['拒绝'],
    example: 'Refuser une invitation.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'refus',
        type: 'n.m.',
        meaning: '拒绝',
        usage: 'Essuyer un refus.',
        example: 'Essuyer un refus.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 287,
    word: 'regarder',
    phonetic: '/rəɡarde/',
    type: 'v.t.',
    translation: '看；注视',
    commonMeanings: ['看', '注视'],
    example: 'Regarder la télévision.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'regard',
        type: 'n.m.',
        meaning: '眼神/注视',
        usage: 'Un regard lointain.',
        example: 'Un regard lointain.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 288,
    word: 'regretter',
    phonetic: '/rəɡrɛte/',
    type: 'v.t.',
    translation: '后悔；怀念',
    commonMeanings: ['后悔', '怀念'],
    example: 'Regretter ses erreurs.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'regret',
        type: 'n.m.',
        meaning: '后悔',
        usage: 'Avoir des regrets.',
        example: 'Avoir des regrets.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 289,
    word: 'rejeter',
    phonetic: '/rəʒte/',
    type: 'v.t.',
    translation: '拒绝；抛弃',
    commonMeanings: ['拒绝', '抛弃'],
    example: 'Rejeter une proposition.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'rejet',
        type: 'n.m.',
        meaning: '拒绝/排斥',
        usage: "Le rejet d'une greffe.",
        example: "Le rejet d'une greffe.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 290,
    word: 'répéter',
    phonetic: '/repete/',
    type: 'v.t.',
    translation: '重复；排练',
    commonMeanings: ['重复', '排练'],
    example: 'Répéter une leçon.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'répétition',
        type: 'n.f.',
        meaning: '重复/排演',
        usage: 'Une répétition générale.',
        example: 'Une répétition générale.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 291,
    word: 'répondre',
    phonetic: '/repɔ̃dr/',
    type: 'v.i.',
    translation: '回答',
    commonMeanings: ['回答'],
    example: 'Répondre à une question.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'réponse',
        type: 'n.f.',
        meaning: '回答',
        usage: 'Donner une réponse.',
        example: 'Donner une réponse.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 292,
    word: 'reposer',
    phonetic: '/rəpoze/',
    type: 'v.t./v.pr.',
    translation: '休息；安放',
    commonMeanings: ['休息', '安放'],
    example: 'Se reposer après le travail.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'repos',
        type: 'n.m.',
        meaning: '休息',
        usage: 'Prendre du repos.',
        example: 'Prendre du repos.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 293,
    word: 'reprendre',
    phonetic: '/rəprɑ̃dr/',
    type: 'v.t.',
    translation: '重新开始；取回',
    commonMeanings: ['重新开始', '取回'],
    example: 'Reprendre ses études.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'reprise',
        type: 'n.f.',
        meaning: '恢复/重演',
        usage: 'La reprise économique.',
        example: 'La reprise économique.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 294,
    word: 'représenter',
    phonetic: '/rəprezɑ̃te/',
    type: 'v.t.',
    translation: '代表；表现',
    commonMeanings: ['代表', '表现'],
    example: 'Représenter un pays.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'représentant',
        type: 'n.m.',
        meaning: '代表',
        usage: 'Un représentant de commerce.',
        example: 'Un représentant de commerce.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 295,
    word: 'reprocher',
    phonetic: '/rəprɔʃe/',
    type: 'v.t.',
    translation: '责备',
    commonMeanings: ['责备'],
    example: 'Reprocher une faute à qqn.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'reproche',
        type: 'n.m.',
        meaning: '责备',
        usage: 'Faire des reproches.',
        example: 'Faire des reproches.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 296,
    word: 'résoudre',
    phonetic: '/rezudr/',
    type: 'v.t.',
    translation: '解决',
    commonMeanings: ['解决'],
    example: 'Résoudre un problème.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'résolution',
        type: 'n.f.',
        meaning: '解决/决心',
        usage: 'Prendre une résolution.',
        example: 'Prendre une résolution.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 297,
    word: 'respecter',
    phonetic: '/rɛspɛkte/',
    type: 'v.t.',
    translation: '尊重',
    commonMeanings: ['尊重'],
    example: 'Respecter la loi.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'respect',
        type: 'n.m.',
        meaning: '尊重',
        usage: 'Manquer de respect.',
        example: 'Manquer de respect.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 298,
    word: 'ressembler',
    phonetic: '/rəsɑ̃ble/',
    type: 'v.i.',
    translation: '相像',
    commonMeanings: ['相像'],
    example: 'Il ressemble à son père.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'ressemblance',
        type: 'n.f.',
        meaning: '相似',
        usage: 'Une ressemblance frappante.',
        example: 'Une ressemblance frappante.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 299,
    word: 'ressentir',
    phonetic: '/rəsɑ̃tir/',
    type: 'v.t.',
    translation: '感觉到',
    commonMeanings: ['感觉到'],
    example: 'Ressentir de la joie.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'sentiment',
        type: 'n.m.',
        meaning: '感情',
        usage: 'Un sentiment profond.',
        example: 'Un sentiment profond.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 300,
    word: 'rester',
    phonetic: '/rɛste/',
    type: 'v.i.',
    translation: '停留；保持',
    commonMeanings: ['停留', '保持'],
    example: 'Rester à la maison.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'reste',
        type: 'n.m.',
        meaning: '剩余',
        usage: 'Le reste du temps.',
        example: 'Le reste du temps.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 301,
    word: 'retenir',
    phonetic: '/rətnir/',
    type: 'v.t.',
    translation: '留住；记住',
    commonMeanings: ['留住', '记住'],
    example: 'Retenir une leçon.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'retenue',
        type: 'n.f.',
        meaning: '扣留/谨慎',
        usage: 'Faire preuve de retenue.',
        example: 'Faire preuve de retenue.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 302,
    word: 'retirer',
    phonetic: '/rətire/',
    type: 'v.t./v.pr.',
    translation: '撤回；提取',
    commonMeanings: ['撤回', '提取'],
    example: "Retirer de l'argent.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'retraite',
        type: 'n.f.',
        meaning: '退休/撤退',
        usage: 'Prendre sa retraite.',
        example: 'Prendre sa retraite.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 303,
    word: 'retourner',
    phonetic: '/rəturne/',
    type: 'v.i./v.t.',
    translation: '返回；翻转',
    commonMeanings: ['返回', '翻转'],
    example: 'Retourner au bureau.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'retour',
        type: 'n.m.',
        meaning: '返回',
        usage: 'Un billet aller-retour.',
        example: 'Un billet aller-retour.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 304,
    word: 'retrouver',
    phonetic: '/rətruve/',
    type: 'v.t.',
    translation: '找回；重逢',
    commonMeanings: ['找回', '重逢'],
    example: 'Retrouver ses clés.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'retrouvailles',
        type: 'n.f.pl.',
        meaning: '重逢',
        usage: 'De joyeuses retrouvailles.',
        example: 'De joyeuses retrouvailles.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 305,
    word: 'réussir',
    phonetic: '/reysir/',
    type: 'v.i./v.t.',
    translation: '成功',
    commonMeanings: ['成功'],
    example: 'Réussir à un examen.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'réussite',
        type: 'n.f.',
        meaning: '成功',
        usage: 'Une belle réussite.',
        example: 'Une belle réussite.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 306,
    word: 'réveiller',
    phonetic: '/reveje/',
    type: 'v.t./v.pr.',
    translation: '唤醒',
    commonMeanings: ['唤醒'],
    example: 'Se réveiller tôt.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'réveil',
        type: 'n.m.',
        meaning: '闹钟/觉醒',
        usage: 'Le réveil sonne.',
        example: 'Le réveil sonne.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 307,
    word: 'révéler',
    phonetic: '/revele/',
    type: 'v.t.',
    translation: '揭露',
    commonMeanings: ['揭露'],
    example: 'Révéler un secret.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'révélation',
        type: 'n.f.',
        meaning: '揭示',
        usage: 'Une révélation choc.',
        example: 'Une révélation choc.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 308,
    word: 'revenir',
    phonetic: '/rəvnir/',
    type: 'v.i.',
    translation: '回来',
    commonMeanings: ['回来'],
    example: 'Revenir de voyage.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'revenu',
        type: 'n.m.',
        meaning: '收入',
        usage: 'Un revenu annuel.',
        example: 'Un revenu annuel.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 309,
    word: 'rêver',
    phonetic: '/reve/',
    type: 'v.i./v.t.',
    translation: '做梦',
    commonMeanings: ['做梦'],
    example: 'Rêver de voyager.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'rêve',
        type: 'n.m.',
        meaning: '梦',
        usage: 'Faire un beau rêve.',
        example: 'Faire un beau rêve.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 310,
    word: 'revoir',
    phonetic: '/rəvwar/',
    type: 'v.t.',
    translation: '再见；复习',
    commonMeanings: ['再见', '复习'],
    example: 'Revoir un ami.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'revue',
        type: 'n.f.',
        meaning: '杂志/复查',
        usage: 'Une revue de presse.',
        example: 'Une revue de presse.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 311,
    word: 'rire',
    phonetic: '/rir/',
    type: 'v.i.',
    translation: '笑',
    commonMeanings: ['笑'],
    example: 'Rire aux éclats.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'rire',
        type: 'n.m.',
        meaning: '笑声',
        usage: 'Un rire nerveux.',
        example: 'Un rire nerveux.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 312,
    word: 'risquer',
    phonetic: '/riske/',
    type: 'v.t.',
    translation: '冒险',
    commonMeanings: ['冒险'],
    example: 'Risquer sa vie.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'risque',
        type: 'n.m.',
        meaning: '风险',
        usage: 'Prendre des risques.',
        example: 'Prendre des risques.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 313,
    word: 'rompre',
    phonetic: '/rɔ̃pr/',
    type: 'v.t./v.i.',
    translation: '打断；分手',
    commonMeanings: ['打断', '分手'],
    example: 'Rompre le silence.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'rupture',
        type: 'n.f.',
        meaning: '破裂/断绝',
        usage: 'Une rupture de contrat.',
        example: 'Une rupture de contrat.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 314,
    word: 'rouler',
    phonetic: '/rule/',
    type: 'v.i./v.t.',
    translation: '滚动；行驶',
    commonMeanings: ['滚动', '行驶'],
    example: 'La voiture roule vite.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'roulement',
        type: 'n.m.',
        meaning: '滚动/周转',
        usage: 'Un roulement à billes.',
        example: 'Un roulement à billes.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 315,
    word: 'saisir',
    phonetic: '/sezir/',
    type: 'v.t.',
    translation: '抓住；理解',
    commonMeanings: ['抓住', '理解'],
    example: 'Saisir une occasion.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'saisie',
        type: 'n.f.',
        meaning: '扣押/输入',
        usage: 'La saisie des données.',
        example: 'La saisie des données.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 316,
    word: 'saluer',
    phonetic: '/salue/',
    type: 'v.t.',
    translation: '问候；敬礼',
    commonMeanings: ['问候', '敬礼'],
    example: 'Saluer son voisin.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'salut',
        type: 'n.m.',
        meaning: '问候/救赎',
        usage: 'Un salut amical.',
        example: 'Un salut amical.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 317,
    word: 'satisfaire',
    phonetic: '/satisfɛr/',
    type: 'v.t.',
    translation: '使满意',
    commonMeanings: ['使满意'],
    example: 'Satisfaire les clients.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'satisfaction',
        type: 'n.f.',
        meaning: '满意',
        usage: 'Donner satisfaction.',
        example: 'Donner satisfaction.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 318,
    word: 'savoir',
    phonetic: '/savwar/',
    type: 'v.t.',
    translation: '知道；会',
    commonMeanings: ['知道', '会'],
    example: 'Je ne sais pas.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'savoir',
        type: 'n.m.',
        meaning: '知识',
        usage: 'Le savoir-faire.',
        example: 'Le savoir-faire.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 319,
    word: 'sembler',
    phonetic: '/sɑ̃ble/',
    type: 'v.i.',
    translation: '好像',
    commonMeanings: ['好像'],
    example: 'Il semble content.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'semblant',
        type: 'n.m.',
        meaning: '假装',
        usage: 'Faire semblant de.',
        example: 'Faire semblant de.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 320,
    word: 'sentir',
    phonetic: '/sɑ̃tir/',
    type: 'v.t./v.i.',
    translation: '感觉；闻',
    commonMeanings: ['感觉', '闻'],
    example: 'Sentir une odeur.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'sentier',
        type: 'n.m.',
        meaning: '小径',
        usage: 'Un sentier de randonnée.',
        example: 'Un sentier de randonnée.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 321,
    word: 'séparer',
    phonetic: '/separe/',
    type: 'v.t.',
    translation: '分隔；使分离',
    commonMeanings: ['分隔', '使分离'],
    example: 'Séparer le vrai du faux.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'séparation',
        type: 'n.f.',
        meaning: '分离',
        usage: 'Une séparation douloureuse.',
        example: 'Une séparation douloureuse.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 322,
    word: 'serrer',
    phonetic: '/sɛre/',
    type: 'v.t.',
    translation: '握紧；挤',
    commonMeanings: ['握紧', '挤'],
    example: "Serrer la main à quelqu'un.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'serrure',
        type: 'n.f.',
        meaning: '锁',
        usage: 'Changer la serrure.',
        example: 'Changer la serrure.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 323,
    word: 'servir',
    phonetic: '/sɛrvir/',
    type: 'v.t./v.i.',
    translation: '服务；有用',
    commonMeanings: ['服务', '有用'],
    example: 'À quoi ça sert ?',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'service',
        type: 'n.m.',
        meaning: '服务',
        usage: 'Rendre un service.',
        example: 'Rendre un service.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 324,
    word: 'signer',
    phonetic: '/siɲe/',
    type: 'v.t.',
    translation: '签名',
    commonMeanings: ['签名'],
    example: 'Signer un contrat.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'signature',
        type: 'n.f.',
        meaning: '签名',
        usage: 'Apposer sa signature.',
        example: 'Apposer sa signature.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 325,
    word: 'signifier',
    phonetic: '/siɲifje/',
    type: 'v.t.',
    translation: '意味着；表示',
    commonMeanings: ['意味着', '表示'],
    example: 'Que signifie ce mot ?',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'signification',
        type: 'n.f.',
        meaning: '含义',
        usage: "La signification d'un geste.",
        example: "La signification d'un geste.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 326,
    word: 'soigner',
    phonetic: '/swaɲe/',
    type: 'v.t.',
    translation: '照料；医治',
    commonMeanings: ['照料', '医治'],
    example: 'Soigner un malade.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'soin',
        type: 'n.m.',
        meaning: '照料',
        usage: 'Prendre soin de soi.',
        example: 'Prendre soin de soi.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 327,
    word: 'solliciter',
    phonetic: '/sɔlisite/',
    type: 'v.t.',
    translation: '请求；恳求',
    commonMeanings: ['请求', '恳求'],
    example: 'Solliciter une audience.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'sollicitation',
        type: 'n.f.',
        meaning: '请求',
        usage: 'Répondre aux sollicitations.',
        example: 'Répondre aux sollicitations.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 328,
    word: 'songer',
    phonetic: '/sɔ̃ʒe/',
    type: 'v.i.',
    translation: '考虑；想到',
    commonMeanings: ['考虑', '想到'],
    example: 'Je songe à changer de travail.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'songe',
        type: 'n.m.',
        meaning: '梦',
        usage: 'Perdu dans ses songes.',
        example: 'Perdu dans ses songes.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 329,
    word: 'sonner',
    phonetic: '/sɔne/',
    type: 'v.i./v.t.',
    translation: '响；按铃',
    commonMeanings: ['响', '按铃'],
    example: 'Le réveil sonne à sept heures.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'sonnette',
        type: 'n.f.',
        meaning: '门铃',
        usage: "Tirer la sonnette d'alarme.",
        example: "Tirer la sonnette d'alarme.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 330,
    word: 'sortir',
    phonetic: '/sɔrtir/',
    type: 'v.i./v.t.',
    translation: '出去；拿出',
    commonMeanings: ['出去', '拿出'],
    example: 'Sortir avec des amis.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'sortie',
        type: 'n.f.',
        meaning: '出口',
        usage: 'La sortie de secours.',
        example: 'La sortie de secours.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 331,
    word: 'souffrir',
    phonetic: '/sufrir/',
    type: 'v.i./v.t.',
    translation: '受苦；忍受',
    commonMeanings: ['受苦', '忍受'],
    example: 'Souffrir de la chaleur.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'souffrance',
        type: 'n.f.',
        meaning: '痛苦',
        usage: 'Abréger les souffrances.',
        example: 'Abréger les souffrances.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 332,
    word: 'souhaiter',
    phonetic: '/swɛte/',
    type: 'v.t.',
    translation: '希望；祝愿',
    commonMeanings: ['希望', '祝愿'],
    example: 'Je vous souhaite bonne chance.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'souhait',
        type: 'n.m.',
        meaning: '愿望',
        usage: 'Meilleurs souhaits.',
        example: 'Meilleurs souhaits.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 333,
    word: 'souligner',
    phonetic: '/suliɲe/',
    type: 'v.t.',
    translation: '强调；划线',
    commonMeanings: ['强调', '划线'],
    example: "Souligner l'importance de qch.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'ligne',
        type: 'n.f.',
        meaning: '线',
        usage: 'Écrire une ligne.',
        example: 'Écrire une ligne.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 334,
    word: 'soupçonner',
    phonetic: '/supsɔne/',
    type: 'v.t.',
    translation: '怀疑',
    commonMeanings: ['怀疑'],
    example: 'On le soupçonne de vol.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'soupçon',
        type: 'n.m.',
        meaning: '怀疑',
        usage: 'Au-dessus de tout soupçon.',
        example: 'Au-dessus de tout soupçon.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 335,
    word: 'sourire',
    phonetic: '/surir/',
    type: 'v.i.',
    translation: '微笑',
    commonMeanings: ['微笑'],
    example: 'Elle sourit tout le temps.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'sourire',
        type: 'n.m.',
        meaning: '微笑',
        usage: 'Un beau sourire.',
        example: 'Un beau sourire.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 336,
    word: 'se souvenir',
    phonetic: '/sə suvnir/',
    type: 'v.pr.',
    translation: '回想起',
    commonMeanings: ['回想起'],
    example: 'Je me souviens de ce jour.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'souvenir',
        type: 'n.m.',
        meaning: '回忆',
        usage: "Un souvenir d'enfance.",
        example: "Un souvenir d'enfance.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 337,
    word: 'subir',
    phonetic: '/sybir/',
    type: 'v.t.',
    translation: '遭受；忍受',
    commonMeanings: ['遭受', '忍受'],
    example: 'Subir un échec.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'subi',
        type: 'adj.',
        meaning: '遭受的',
        usage: 'Un changement subi.',
        example: 'Un changement subi.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 338,
    word: 'succéder',
    phonetic: '/syksede/',
    type: 'v.i.',
    translation: '继承；接替',
    commonMeanings: ['继承', '接替'],
    example: 'Succéder à son père.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'succession',
        type: 'n.f.',
        meaning: '继承',
        usage: 'La succession au trône.',
        example: 'La succession au trône.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 339,
    word: 'suffire',
    phonetic: '/syfir/',
    type: 'v.i.',
    translation: '足够',
    commonMeanings: ['足够'],
    example: 'Cela suffit !',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'suffisant',
        type: 'adj.',
        meaning: '足够的',
        usage: 'Une preuve suffisante.',
        example: 'Une preuve suffisante.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 340,
    word: 'suggérer',
    phonetic: '/syɡʒere/',
    type: 'v.t.',
    translation: '建议；启发',
    commonMeanings: ['建议', '启发'],
    example: 'Suggérer une idée.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'suggestion',
        type: 'n.f.',
        meaning: '建议',
        usage: 'Faire une suggestion.',
        example: 'Faire une suggestion.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 341,
    word: 'suivre',
    phonetic: '/sɥivr/',
    type: 'v.t.',
    translation: '跟随；遵守',
    commonMeanings: ['跟随', '遵守'],
    example: 'Suivez le guide.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'suivant',
        type: 'adj.',
        meaning: '下一个',
        usage: 'La page suivante.',
        example: 'La page suivante.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 342,
    word: 'supporter',
    phonetic: '/sypɔrte/',
    type: 'v.t.',
    translation: '支持；忍受',
    commonMeanings: ['支持', '忍受'],
    example: 'Ne pas supporter le bruit.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'support',
        type: 'n.m.',
        meaning: '支架/载体',
        usage: 'Un support technique.',
        example: 'Un support technique.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 343,
    word: 'supposer',
    phonetic: '/sypoze/',
    type: 'v.t.',
    translation: '假定',
    commonMeanings: ['假定'],
    example: "Je suppose qu'il a oublié.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'supposition',
        type: 'n.f.',
        meaning: '假定',
        usage: 'Pure supposition.',
        example: 'Pure supposition.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 344,
    word: 'surprendre',
    phonetic: '/syrprɑ̃dr/',
    type: 'v.t.',
    translation: '使惊讶；撞见',
    commonMeanings: ['使惊讶', '撞见'],
    example: 'Surprendre qqn en flagrant délit.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'surprise',
        type: 'n.f.',
        meaning: '惊喜',
        usage: 'Quelle surprise !',
        example: 'Quelle surprise !',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 345,
    word: 'surveiller',
    phonetic: '/syrveje/',
    type: 'v.t.',
    translation: '监视；看管',
    commonMeanings: ['监视', '看管'],
    example: 'Surveiller les enfants.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'surveillance',
        type: 'n.f.',
        meaning: '监视',
        usage: 'Sous surveillance médicale.',
        example: 'Sous surveillance médicale.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 346,
    word: 'survivre',
    phonetic: '/syrvivr/',
    type: 'v.i.',
    translation: '幸存',
    commonMeanings: ['幸存'],
    example: 'Survivre à une catastrophe.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'survivant',
        type: 'n.m.',
        meaning: '幸存者',
        usage: 'Les survivants du crash.',
        example: 'Les survivants du crash.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 347,
    word: 'tacher',
    phonetic: '/taʃe/',
    type: 'v.t.',
    translation: '弄脏',
    commonMeanings: ['弄脏'],
    example: 'Tacher sa chemise.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'tache',
        type: 'n.f.',
        meaning: '污点',
        usage: 'Une tache de vin.',
        example: 'Une tache de vin.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 348,
    word: 'tâcher',
    phonetic: '/taʃe/',
    type: 'v.i.',
    translation: '努力；设法',
    commonMeanings: ['努力', '设法'],
    example: 'Tâcher de bien faire.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'tâche',
        type: 'n.f.',
        meaning: '任务',
        usage: 'Une tâche difficile.',
        example: 'Une tâche difficile.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 349,
    word: 'taire',
    phonetic: '/tɛr/',
    type: 'v.t./v.pr.',
    translation: '隐瞒；沉默',
    commonMeanings: ['隐瞒', '沉默'],
    example: 'Se taire pour écouter.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'taciturne',
        type: 'adj.',
        meaning: '沉默寡言的',
        usage: 'Un homme taciturne.',
        example: 'Un homme taciturne.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 350,
    word: 'taper',
    phonetic: '/tape/',
    type: 'v.t./v.i.',
    translation: '敲；打字',
    commonMeanings: ['敲', '打字'],
    example: 'Tapez votre mot de passe.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'tapis',
        type: 'n.m.',
        meaning: '地毯',
        usage: 'Sous le tapis.',
        example: 'Sous le tapis.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 351,
    word: 'tarder',
    phonetic: '/tarde/',
    type: 'v.i.',
    translation: '耽搁；延迟',
    commonMeanings: ['耽搁', '延迟'],
    example: 'Ne tardez pas à répondre.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'tard',
        type: 'adv.',
        meaning: '晚',
        usage: 'Il est tard.',
        example: 'Il est tard.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 352,
    word: 'téléphoner',
    phonetic: '/telefɔne/',
    type: 'v.i.',
    translation: '打电话',
    commonMeanings: ['打电话'],
    example: 'Téléphoner à ses parents.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'téléphone',
        type: 'n.m.',
        meaning: '电话',
        usage: 'Passer un coup de téléphone.',
        example: 'Passer un coup de téléphone.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 353,
    word: 'témoigner',
    phonetic: '/temwaɲe/',
    type: 'v.t./v.i.',
    translation: '证明；表达',
    commonMeanings: ['证明', '表达'],
    example: 'Témoigner de la reconnaissance.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'témoin',
        type: 'n.m.',
        meaning: '证人',
        usage: 'Un témoin oculaire.',
        example: 'Un témoin oculaire.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 354,
    word: 'tendre',
    phonetic: '/tɑ̃dr/',
    type: 'v.t.',
    translation: '伸出；拉紧',
    commonMeanings: ['伸出', '拉紧'],
    example: 'Tendre la main.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'tendresse',
        type: 'n.f.',
        meaning: '温柔',
        usage: 'Avec tendresse.',
        example: 'Avec tendresse.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 355,
    word: 'tenir',
    phonetic: '/tənir/',
    type: 'v.t./v.i.',
    translation: '拿着；坚持',
    commonMeanings: ['拿着', '坚持'],
    example: 'Tenir sa promesse.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'tenue',
        type: 'n.f.',
        meaning: '服装/举止',
        usage: 'Une tenue correcte.',
        example: 'Une tenue correcte.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 356,
    word: 'tenter',
    phonetic: '/tɑ̃te/',
    type: 'v.t.',
    translation: '试图；诱惑',
    commonMeanings: ['试图', '诱惑'],
    example: 'Tenter une expérience.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'tentative',
        type: 'n.f.',
        meaning: '尝试',
        usage: 'Une tentative de vol.',
        example: 'Une tentative de vol.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 357,
    word: 'terminer',
    phonetic: '/tɛrmine/',
    type: 'v.t.',
    translation: '结束',
    commonMeanings: ['结束'],
    example: 'Terminer son travail.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'terme',
        type: 'n.m.',
        meaning: '期限/词语',
        usage: 'À long terme.',
        example: 'À long terme.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 358,
    word: 'tirer',
    phonetic: '/tire/',
    type: 'v.t.',
    translation: '拉；抽出；打(球)',
    commonMeanings: ['拉', '抽出', '打(球)'],
    example: 'Tirer la sonnette.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'tirage',
        type: 'n.m.',
        meaning: '印刷/抽奖',
        usage: 'Le tirage au sort.',
        example: 'Le tirage au sort.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 359,
    word: 'tomber',
    phonetic: '/tɔ̃be/',
    type: 'v.i.',
    translation: '掉下；摔倒',
    commonMeanings: ['掉下', '摔倒'],
    example: 'La pluie tombe.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'tombée',
        type: 'n.f.',
        meaning: '落下',
        usage: 'La tombée de la nuit.',
        example: 'La tombée de la nuit.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 360,
    word: 'toucher',
    phonetic: '/tuʃe/',
    type: 'v.t.',
    translation: '触摸；感动',
    commonMeanings: ['触摸', '感动'],
    example: 'Ne touchez à rien.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'touchant',
        type: 'adj.',
        meaning: '感人的',
        usage: 'Un film touchant.',
        example: 'Un film touchant.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 361,
    word: 'tourner',
    phonetic: '/turne/',
    type: 'v.t./v.i.',
    translation: '旋转；拐弯',
    commonMeanings: ['旋转', '拐弯'],
    example: 'Tourner à gauche.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'tour',
        type: 'n.m./n.f.',
        meaning: '轮流/塔',
        usage: 'Faire le tour.',
        example: 'Faire le tour.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 362,
    word: 'tracer',
    phonetic: '/trase/',
    type: 'v.t.',
    translation: '描绘；画(线)',
    commonMeanings: ['描绘', '画(线)'],
    example: 'Tracer un plan.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'trace',
        type: 'n.f.',
        meaning: '痕迹',
        usage: 'Suivre les traces.',
        example: 'Suivre les traces.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 363,
    word: 'traduire',
    phonetic: '/tradɥir/',
    type: 'v.t.',
    translation: '翻译',
    commonMeanings: ['翻译'],
    example: 'Traduire un texte.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'traduction',
        type: 'n.f.',
        meaning: '翻译',
        usage: 'Une traduction fidèle.',
        example: 'Une traduction fidèle.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 364,
    word: 'traîner',
    phonetic: '/trɛne/',
    type: 'v.t./v.i.',
    translation: '拖；闲逛',
    commonMeanings: ['拖', '闲逛'],
    example: 'Ne traînez pas en chemin.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'traîneau',
        type: 'n.m.',
        meaning: '雪橇',
        usage: 'Un chien de traîneau.',
        example: 'Un chien de traîneau.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 365,
    word: 'traiter',
    phonetic: '/trɛte/',
    type: 'v.t.',
    translation: '处理；对待',
    commonMeanings: ['处理', '对待'],
    example: 'Traiter une affaire.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'traitement',
        type: 'n.m.',
        meaning: '处理/薪水',
        usage: 'Un traitement médical.',
        example: 'Un traitement médical.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 366,
    word: 'transformer',
    phonetic: '/trɑ̃sfɔrme/',
    type: 'v.t.',
    translation: '改变；转换',
    commonMeanings: ['改变', '转换'],
    example: 'Transformer un essai.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'transformation',
        type: 'n.f.',
        meaning: '变化',
        usage: 'Une transformation radicale.',
        example: 'Une transformation radicale.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 367,
    word: 'transmettre',
    phonetic: '/trɑ̃smɛtr/',
    type: 'v.t.',
    translation: '转达；传递',
    commonMeanings: ['转达', '传递'],
    example: 'Transmettre un message.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'transmission',
        type: 'n.f.',
        meaning: '传达',
        usage: 'La transmission de savoir.',
        example: 'La transmission de savoir.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 368,
    word: 'transporter',
    phonetic: '/trɑ̃spɔrte/',
    type: 'v.t.',
    translation: '运输',
    commonMeanings: ['运输'],
    example: 'Transporter des marchandises.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'transport',
        type: 'n.m.',
        meaning: '交通/运输',
        usage: 'Les transports en commun.',
        example: 'Les transports en commun.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 369,
    word: 'travailler',
    phonetic: '/travaje/',
    type: 'v.i.',
    translation: '工作',
    commonMeanings: ['工作'],
    example: 'Travailler dur.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'travail',
        type: 'n.m.',
        meaning: '工作',
        usage: 'Chercher du travail.',
        example: 'Chercher du travail.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 370,
    word: 'traverser',
    phonetic: '/travɛrse/',
    type: 'v.t.',
    translation: '横穿',
    commonMeanings: ['横穿'],
    example: 'Traverser la rue.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'traversée',
        type: 'n.f.',
        meaning: '航行/横渡',
        usage: 'La traversée de la mer.',
        example: 'La traversée de la mer.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 371,
    word: 'trembler',
    phonetic: '/trɑ̃ble/',
    type: 'v.i.',
    translation: '发抖',
    commonMeanings: ['发抖'],
    example: 'Trembler de froid.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'tremblement',
        type: 'n.m.',
        meaning: '震动',
        usage: 'Un tremblement de terre.',
        example: 'Un tremblement de terre.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 372,
    word: 'tromper',
    phonetic: '/trɔ̃pe/',
    type: 'v.t./v.pr.',
    translation: '欺骗；(自)搞错',
    commonMeanings: ['欺骗', '(自)搞错'],
    example: 'Se tromper de numéro.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'trompeur',
        type: 'adj.',
        meaning: '骗人的',
        usage: 'Les apparences sont trompeuses.',
        example: 'Les apparences sont trompeuses.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 373,
    word: 'trouver',
    phonetic: '/truve/',
    type: 'v.t.',
    translation: '找到；觉得',
    commonMeanings: ['找到', '觉得'],
    example: "Je trouve que c'est bien.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'trouvaille',
        type: 'n.f.',
        meaning: '发现/妙招',
        usage: 'Une trouvaille géniale.',
        example: 'Une trouvaille géniale.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 374,
    word: 'tuer',
    phonetic: '/tɥe/',
    type: 'v.t.',
    translation: '杀死',
    commonMeanings: ['杀死'],
    example: 'Tuer le temps.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'tueur',
        type: 'n.m.',
        meaning: '杀手',
        usage: 'Un tueur à gages.',
        example: 'Un tueur à gages.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 375,
    word: 'unir',
    phonetic: '/ynir/',
    type: 'v.t.',
    translation: '联合；团结',
    commonMeanings: ['联合', '团结'],
    example: "L'union fait la force.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'unité',
        type: 'n.f.',
        meaning: '单位/统一',
        usage: "L'unité nationale.",
        example: "L'unité nationale.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 376,
    word: 'user',
    phonetic: '/yze/',
    type: 'v.t.',
    translation: '磨损；消耗',
    commonMeanings: ['磨损', '消耗'],
    example: 'User ses chaussures.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'usure',
        type: 'n.f.',
        meaning: '磨损/高利贷',
        usage: "L'usure du temps.",
        example: "L'usure du temps.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 377,
    word: 'utiliser',
    phonetic: '/ytilize/',
    type: 'v.t.',
    translation: '使用',
    commonMeanings: ['使用'],
    example: 'Utiliser un dictionnaire.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'utilisateur',
        type: 'n.m.',
        meaning: '用户',
        usage: "Guide de l'utilisateur.",
        example: "Guide de l'utilisateur.",
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 378,
    word: 'vaincre',
    phonetic: '/vɛ̃kr/',
    type: 'v.t.',
    translation: '战胜',
    commonMeanings: ['战胜'],
    example: 'Vaincre ses peurs.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'vainqueur',
        type: 'n.m.',
        meaning: '胜利者',
        usage: 'Le vainqueur du tournoi.',
        example: 'Le vainqueur du tournoi.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 379,
    word: 'valoir',
    phonetic: '/valwar/',
    type: 'v.i./v.t.',
    translation: '价值；等于',
    commonMeanings: ['价值', '等于'],
    example: 'Cela vaut la peine.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'valeur',
        type: 'n.f.',
        meaning: '价值',
        usage: 'Une valeur sûre.',
        example: 'Une valeur sûre.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 380,
    word: 'vendre',
    phonetic: '/vɑ̃dr/',
    type: 'v.t.',
    translation: '卖',
    commonMeanings: ['卖'],
    example: 'Vendre sa voiture.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'vendeur',
        type: 'n.m.',
        meaning: '售货员',
        usage: 'Un bon vendeur.',
        example: 'Un bon vendeur.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 381,
    word: 'venger',
    phonetic: '/vɑ̃ʒe/',
    type: 'v.t.',
    translation: '报复；报仇',
    commonMeanings: ['报复', '报仇'],
    example: 'Venger un affront.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'vengeance',
        type: 'n.f.',
        meaning: '报仇',
        usage: 'Tirer vengeance de.',
        example: 'Tirer vengeance de.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 382,
    word: 'venir',
    phonetic: '/vənir/',
    type: 'v.i.',
    translation: '来',
    commonMeanings: ['来'],
    example: 'Je viens de Paris.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'venue',
        type: 'n.f.',
        meaning: '来临',
        usage: 'Attendre sa venue.',
        example: 'Attendre sa venue.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 383,
    word: 'vérifier',
    phonetic: '/verifje/',
    type: 'v.t.',
    translation: '核实；检查',
    commonMeanings: ['核实', '检查'],
    example: 'Vérifier ses calculs.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'vérification',
        type: 'n.f.',
        meaning: '检查',
        usage: 'Faire une vérification.',
        example: 'Faire une vérification.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 384,
    word: 'verser',
    phonetic: '/vɛrse/',
    type: 'v.t.',
    translation: '倒；支付',
    commonMeanings: ['倒', '支付'],
    example: 'Verser du vin.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'versement',
        type: 'n.m.',
        meaning: '汇款/支付',
        usage: 'Effectuer un versement.',
        example: 'Effectuer un versement.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 385,
    word: 'vêtir',
    phonetic: '/vɛtir/',
    type: 'v.t.',
    translation: '给...穿衣',
    commonMeanings: ['给...穿衣'],
    example: 'Vêtir un enfant.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'vêtement',
        type: 'n.m.',
        meaning: '衣服',
        usage: 'Acheter des vêtements.',
        example: 'Acheter des vêtements.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 386,
    word: 'vider',
    phonetic: '/vide/',
    type: 'v.t.',
    translation: '倒空',
    commonMeanings: ['倒空'],
    example: 'Vider son sac.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'vide',
        type: 'n.m./adj.',
        meaning: '空地/空的',
        usage: 'Avoir les mains vides.',
        example: 'Avoir les mains vides.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 387,
    word: 'vieillir',
    phonetic: '/vjejjir/',
    type: 'v.i.',
    translation: '变老',
    commonMeanings: ['变老'],
    example: 'Il ne vieillit pas.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'vieillesse',
        type: 'n.f.',
        meaning: '老年',
        usage: 'Profiter de sa vieillesse.',
        example: 'Profiter de sa vieillesse.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 388,
    word: 'viser',
    phonetic: '/vize/',
    type: 'v.t.',
    translation: '瞄准；旨在',
    commonMeanings: ['瞄准', '旨在'],
    example: 'Viser le but.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'visée',
        type: 'n.f.',
        meaning: '目标/打算',
        usage: 'Des visées politiques.',
        example: 'Des visées politiques.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 389,
    word: 'visiter',
    phonetic: '/vizite/',
    type: 'v.t.',
    translation: '参观',
    commonMeanings: ['参观'],
    example: 'Visiter un musée.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'visiteur',
        type: 'n.m.',
        meaning: '参观者',
        usage: 'Un visiteur étranger.',
        example: 'Un visiteur étranger.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 390,
    word: 'vivre',
    phonetic: '/vivr/',
    type: 'v.i./v.t.',
    translation: '生活；活着',
    commonMeanings: ['生活', '活着'],
    example: 'Vivre cent ans.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'vivant',
        type: 'adj.',
        meaning: '活着的',
        usage: 'Un témoin vivant.',
        example: 'Un témoin vivant.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 391,
    word: 'voir',
    phonetic: '/vwar/',
    type: 'v.t.',
    translation: '看见',
    commonMeanings: ['看见'],
    example: 'Voir un spectacle.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'vue',
        type: 'n.f.',
        meaning: '视力/风景',
        usage: 'Avoir une belle vue.',
        example: 'Avoir une belle vue.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 392,
    word: 'voler',
    phonetic: '/vɔle/',
    type: 'v.i./v.t.',
    translation: '飞；偷窃',
    commonMeanings: ['飞', '偷窃'],
    example: 'Voler un vélo.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'voleur',
        type: 'n.m.',
        meaning: '小偷',
        usage: 'Au voleur !',
        example: 'Au voleur !',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 393,
    word: 'voter',
    phonetic: '/vɔte/',
    type: 'v.i.',
    translation: '投票',
    commonMeanings: ['投票'],
    example: 'Voter pour un candidat.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'vote',
        type: 'n.m.',
        meaning: '投票',
        usage: 'Le vote est secret.',
        example: 'Le vote est secret.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 394,
    word: 'vouloir',
    phonetic: '/vulwar/',
    type: 'v.t.',
    translation: '想要',
    commonMeanings: ['想要'],
    example: 'Je veux partir.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'volonté',
        type: 'n.f.',
        meaning: '意志',
        usage: 'Faire preuve de volonté.',
        example: 'Faire preuve de volonté.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 395,
    word: 'voyager',
    phonetic: '/vwajaʒe/',
    type: 'v.i.',
    translation: '旅行',
    commonMeanings: ['旅行'],
    example: "Voyager à l'étranger.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'voyageur',
        type: 'n.m.',
        meaning: '旅客',
        usage: 'Un voyageur de commerce.',
        example: 'Un voyageur de commerce.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 396,
    word: 'tutoyer',
    phonetic: '/tytwaje/',
    type: 'v.t.',
    translation: '用“你”称呼',
    commonMeanings: ['用“你”称呼'],
    example: 'On se tutoie ?',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'tutoiement',
        type: 'n.m.',
        meaning: '用“你”称呼',
        usage: 'Passer au tutoiement.',
        example: 'Passer au tutoiement.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 397,
    word: 'vouvoyer',
    phonetic: '/vuvwaje/',
    type: 'v.t.',
    translation: '用“您”称呼',
    commonMeanings: ['用“您”称呼'],
    example: 'Vouvoyer son patron.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'vouvoiement',
        type: 'n.m.',
        meaning: '用“您”称呼',
        usage: 'Le vouvoiement est de rigueur.',
        example: 'Le vouvoiement est de rigueur.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 398,
    word: 'veiller',
    phonetic: '/veje/',
    type: 'v.i.',
    translation: '守候；留意',
    commonMeanings: ['守候', '留意'],
    example: "Veiller sur quelqu'un.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'veille',
        type: 'n.f.',
        meaning: '前夕',
        usage: 'La veille de Noël.',
        example: 'La veille de Noël.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 399,
    word: 'valider',
    phonetic: '/valide/',
    type: 'v.t.',
    translation: '使有效；确认',
    commonMeanings: ['使有效', '确认'],
    example: 'Valider un ticket.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'validité',
        type: 'n.f.',
        meaning: '有效性',
        usage: 'La durée de validité.',
        example: 'La durée de validité.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 400,
    word: 'varier',
    phonetic: '/varje/',
    type: 'v.i./v.t.',
    translation: '变化；改变',
    commonMeanings: ['变化', '改变'],
    example: 'Varier les plaisirs.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'variété',
        type: 'n.f.',
        meaning: '品种/多样性',
        usage: 'Une grande variété.',
        example: 'Une grande variété.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 401,
    word: 'vibrer',
    phonetic: '/vibre/',
    type: 'v.i.',
    translation: '震动',
    commonMeanings: ['震动'],
    example: 'Le téléphone vibre.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'vibration',
        type: 'n.f.',
        meaning: '震动',
        usage: 'Sentir une vibration.',
        example: 'Sentir une vibration.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 402,
    word: 'vaincre',
    phonetic: '/vɛ̃kr/',
    type: 'v.t.',
    translation: '战胜',
    commonMeanings: ['战胜'],
    example: 'Vaincre la peur.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'vainqueur',
        type: 'n.m.',
        meaning: '胜利者',
        usage: 'Le grand vainqueur.',
        example: 'Le grand vainqueur.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 403,
    word: 'viser',
    phonetic: '/vize/',
    type: 'v.t.',
    translation: '瞄准',
    commonMeanings: ['瞄准'],
    example: 'Viser le sommet.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'visée',
        type: 'n.f.',
        meaning: '目的',
        usage: 'Sans aucune visée.',
        example: 'Sans aucune visée.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 404,
    word: 'vomir',
    phonetic: '/vɔmir/',
    type: 'v.i./v.t.',
    translation: '呕吐',
    commonMeanings: ['呕吐'],
    example: 'Envie de vomir.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'vomissement',
        type: 'n.m.',
        meaning: '呕吐',
        usage: 'Des vomissements.',
        example: 'Des vomissements.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 405,
    word: 'vouer',
    phonetic: '/vwe/',
    type: 'v.t.',
    translation: '献身；致力于',
    commonMeanings: ['献身', '致力于'],
    example: "Vouer sa vie à l'art.",
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'dévoué',
        type: 'adj.',
        meaning: '忠诚的',
        usage: 'Votre dévoué serviteur.',
        example: 'Votre dévoué serviteur.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 406,
    word: 'vulgariser',
    phonetic: '/vylɡarize/',
    type: 'v.t.',
    translation: '普及；通俗化',
    commonMeanings: ['普及', '通俗化'],
    example: 'Vulgariser la science.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'vulgarisation',
        type: 'n.f.',
        meaning: '普及',
        usage: 'Un livre de vulgarisation.',
        example: 'Un livre de vulgarisation.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 407,
    word: 'zapper',
    phonetic: '/zape/',
    type: 'v.i.',
    translation: '跳台；跳过',
    commonMeanings: ['跳台', '跳过'],
    example: 'Zapper la publicité.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'zapping',
        type: 'n.m.',
        meaning: '频繁换台',
        usage: 'Faire du zapping.',
        example: 'Faire du zapping.',
      },
    ],
    synonymsAntonyms: [],
  },
  {
    id: 408,
    word: 'zigzaguer',
    phonetic: '/ziɡzaɡe/',
    type: 'v.i.',
    translation: '蜿蜒曲折',
    commonMeanings: ['蜿蜒曲折'],
    example: 'La route zigzague.',
    exampleTranslation: '',
    image: '',
    usages: [],
    derivatives: [
      {
        word: 'zigzag',
        type: 'n.m.',
        meaning: '之字形',
        usage: 'Marcher en zigzag.',
        example: 'Marcher en zigzag.',
      },
    ],
    synonymsAntonyms: [],
  },
];

export const APP_WORDS_SOURCE = DEFAULT_WORDS;
